/// <reference path="jquery-3.6.0.min.js" />
/// <reference path="jRespond.js" />
/// <reference path="jquery.inview.js" />
/// <reference path="owl.carousel.js" />
/// <reference path="jquery.validate.js" />
/// <reference path="formular.js" />
/************************************************* General functions STARTS *************************************************/
// HTML entities helper functions
function htmlEncode(value) {
    'use strict';

    //create a in-memory div, set it's inner text (which jQuery automatically encodes) then grab the encoded contents back out. The div never exists on the page.
    return $('<div/>').text(value).html();
}

function htmlDecode(value) {
    'use strict';

    return $('<div/>').html(value).text(); 
}

function isInArray(value, array) {
    return array.indexOf(value) > -1;
}

// get a specific url parameter
function getUrlParameter(sParam) {
    //url = url !== 'undefined' ? url: decodeURIComponent(window.location.search.substring(1));
    //var sPageURL = url !== 'undefined' ? url: decodeURIComponent(window.location.search.substring(1));
    var sPageURL = decodeURIComponent(window.location.search.substring(1));
    var sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
}

function replaceQueryParam(param, newval, search) {
    var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
    var query = search.replace(regex, "$1").replace(/&$/, '');

    return (query.length > 2 ? query + "&" : "?") + (newval ? param + "=" + newval : '');
}

// check if storage is available
function storageAvailable(type) {
    try {
        var storage = window[type],
            x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch(e) {
        return false;
    }
}

// Overlay closing function
function closeOverlay(type) {
    'use strict';

    var clicktarget = $(type.target);

    if (clicktarget.closest('#overlay-content').length === 0 || clicktarget.attr('id') === 'overlay-close') {
        $(document).off('click', 'body, #overlay-close', closeOverlay);
        $('body').removeClass('overflow-hidden');
        $('#overlay-container, #blur-container').remove();

        return false;
    }
}

function jump(select_element, target_frame){
	eval(target_frame+".location='"+select_element.options[select_element.selectedIndex].value+"'");
} 

// 04.04.2016
function mailToDecrypt(s){
	var n = 0;
	var r = "";
	for( var i = 0; i < s.length; i++){
		n = s.charCodeAt( i );
		if( n >= 8364 ){
			n = 128;
		}
		r += String.fromCharCode( n - 1 );
	}
	return r;
}

// 04.04.2016
function mailDecryptLink(s){
	location.href = mailToDecrypt(s);
}

/**
 * Gets the browser name or returns an empty string if unknown. 
 * This function also caches the result to provide for any 
 * future calls this function has.
 *
 * @returns {string}
 */
var browser = function() {
    // Return cached result if avalible, else get result then cache it.
    if (browser.prototype._cachedResult)
        return browser.prototype._cachedResult;

    // Opera 8.0+
    var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

    // Firefox 1.0+
    var isFirefox = typeof InstallTrigger !== 'undefined';

    // Safari 3.0+ "[object HTMLElementConstructor]" 
    var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

    // Internet Explorer 6-11
    var isIE = /*@cc_on!@*/false || !!document.documentMode;

    // Edge 20+
    var isEdge = !isIE && !!window.StyleMedia;

    // Chrome
    var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);  // 21.09.2019 - CT: Fix

    // Blink engine detection
    var isBlink = (isChrome || isOpera) && !!window.CSS;

    return browser.prototype._cachedResult =
        isOpera ? 'Opera' :
        isFirefox ? 'Firefox' :
        isSafari ? 'Safari' :
        isChrome ? 'Chrome' :
        isIE ? 'IE' :
        isEdge ? 'Edge' :
        isBlink ? 'Blink' :
        "Don't know";
};


// Animate function
$.fn.animateElement = function(options) {
    'use strict';

    var element = this,
        animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';

    var settings = $.extend({
        animtype: element.attr('data-anim'),
        animinitial: element.attr('data-animinitial'),
        animdelay: parseInt(element.attr('data-animdelay'), 10),
        hide: false
    }, options);

    if (isNaN(settings.animdelay)) {
        settings.animdelay = 0;
    }
    setTimeout(function() {
        if (settings.animinitial !== undefined) {
            settings.animtype = settings.animinitial;
            element.removeAttr('data-animinitial');
        }
        element.removeClass('display-none').addClass('animated ' + settings.animtype).one(animationEnd, function() {
            $(this).removeClass('animated ' + settings.animtype);
            if (settings.hide) {
                $(this).addClass('display-none');
            }
        });
    }, settings.animdelay);

    return this;
};

// Funktion zur Prüfung auf korrekte JSON Struktur
function tryParseJSON(jsonString) {
    'use strict';
    try {
        var o = JSON.parse(jsonString);

        if (o && typeof o === "object" && o !== null) {
            return o;
        }
    } catch (ignore) {}

    return false;
}

// Cookie functions
function getCookie(cname) {
    'use strict';

    var name = cname + '=',
        ca = document.cookie.split(';'),
        i,
        c;

    for (i = 0; i < ca.length; i = i + 1) {
        c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

function setCookie(cname, cvalue, exdays) {
    'use strict';

    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toUTCString();
    var ovalue = getCookie(cname);
    if (ovalue !== null && ovalue !== '') {
        cvalue = ovalue + ',' + cvalue;
    }
    document.cookie = cname + '=' + cvalue + '; ' + expires + '; path=/';
}

function checkCookie(cname, id) {
    'use strict';

    var cvalue = getCookie(cname);
    if (cvalue !== null && cvalue.indexOf(id) >= 0) {
        return cvalue;
    } else {
        return null;
    }
}

PNotify.prototype.options.styling = "bootstrap3";
var pnotify_stack_options = {"dir1": "up", "dir2": "left", "firstpos1": 25, "firstpos2": 25};
var pnotify_animate_options = {animate: true, in_class: 'bounceInDown', out_class: 'bounceOutUp'};

function showNotify(text, type, delay) {
    var delay_ms = 3000;

    if (delay !== undefined){
        delay_ms = delay;
    }

    new PNotify({
        //title: title,
        text: text,
        type: type, // Type of the notice. "warning", "info", "success", or "error"
        animate: pnotify_animate_options,
        delay: delay_ms,
        addclass: "stack-bottomright",
        stack: pnotify_stack_options
    });
}

// temporär, um die iOS OS-Version zu ermitteln. Später entfernen und Version aus iOS über GET empfangen.
// geben nur die ersten 2 Stellen zurück. z.B. 15.7.3 wir zu 15.7
function iOSversion() {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
        // supports iOS 2.0 and later: <https://bit.ly/TJjs1V>
        var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
        //return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
        return parseFloat(parseInt(v[1], 10) + '.' + parseInt(v[2], 10));
    }else{
        return null;
    }
}


$(document).ready(function() {
    'use strict';

    /* Declare global Variables */
    var jRes, isMobile, userAgent, play_store_url, ios_store_url, current_locale, lang_ajax_save_error_text, lang_btn_yes, lang_btn_no, lang_btn_cancel, lang_wishlist_reloaded_text, lang_wishlist_wish_added_successfully, lang_wishbob_wishlist_text, lang_add_url_loading_msg, lang_error_occured, lang_try_again, change_wish_pos_error, page_lang, android_app_version, android_latest_app_version;

    /* Android Play Store Url */
    play_store_url = $('body').data('play-store-url');
    /* Apple iOS Store Url */
    ios_store_url = $('body').data('ios-store-url');

    android_app_version = $('body').data('android-app-version');  // User Version
    android_latest_app_version = $('body').data('latest-android-app-version');  // aktuelle Version im Store

    // Beim Ajax Nachladen sollen diese
    function setVariablesForLanguage(){
        // current locale
        current_locale = $('body').data('current-locale');

        // save page language
        page_lang = $('body').data('page-language');

        /* text and messages from data attributes */
        lang_ajax_save_error_text = $('#js-general-texts').data('ajax-error-text');  // Beim Speichern trat ein Fehler auf.
        lang_error_occured = $('#js-general-texts').data('error-occurred-text');  // Ein Fehler ist aufgetreten.
        lang_try_again = $('#js-general-texts').data('error-try-again-text');  // Versuche es bitte erneut.
        lang_btn_yes = $('#js-general-texts').data('btn-yes-text');  // Ja
        lang_btn_no = $('#js-general-texts').data('btn-no-text');  // Nein
        lang_btn_cancel = $('#js-general-texts').data('btn-cancel-text');  // Abbrechen
        lang_wishlist_reloaded_text = $('#js-general-texts').data('wishlist-reloaded-text');  // Der Wunschzettel wurde neu geladen!
        lang_wishlist_wish_added_successfully = $('#js-general-texts').data('wishlist-wish-added-successfully');  // Der Wunsch wurde erfolgreich hinzugefügt!
        lang_wishbob_wishlist_text = $('#js-general-texts').data('wishbob-wishlist-text');  // Wishbob Wunschzettel
        lang_add_url_loading_msg = $('#js-general-texts').data('add-url-loading-message');  // Daten werden geholt...
        change_wish_pos_error = $('#js-general-texts').data('add-url-loading-message');  // Beim Ändern der Wunsch-Positionen ist leider ein Fehler aufgetreten!
    }
    setVariablesForLanguage();
    
    
    /* Remove no-js class at html tag */
    $('html').removeClass('no-js');

    /* Initiate jRespond and assign breakpoints */
    jRes = jRespond([{
        label: 'smartphone',
        enter: 0,
        exit: 767
    }, {
        label: 'tablet',
        enter: 768,
        exit: 991
    }, {
        label: 'desktop',
        enter: 992,
        exit: 10000
    }]);

    isMobile = {
        android: function() {
            return navigator.userAgent.match(/Android/i);
        },
        blackBerry: function() {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        opera: function() {
            return navigator.userAgent.match(/Opera\ Mini/i);
        },
        windows: function() {
            return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
        },
        any: function() {
            return (isMobile.android() || isMobile.blackBerry() || isMobile.iOS() || isMobile.opera() || isMobile.windows());
        }
    };

    /* SweetAlert with History Hash Value */
    var CustomHashSwal = Swal.mixin({
        //animation: false,
        showClass: {
            popup: 'animated fadeIn',  // 23.01.2024 - CT: geändert
        },
        customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-default',
        },
        onOpen: (function (result) {
            window.location.hash = "swal";
            $(window).on('hashchange', function (event) {
                if(window.location.hash != "#swal") {
                    Swal.close();
                }
            });
        }),
        onClose: (function (result) {
            if(window.location.hash == "#swal") {
                window.history.back();
            }
        })
    });


    /* check screen resolution and fix banner height */
    function fixBannerHeight(owlhero) {
        var client_width = screen.width,
            client_height = screen.height;

        if (client_width > 460) {
            $('#hero-banner .banner-container').css('max-height', '');

            var banner_height = owlhero.outerHeight(),
                header_height = $('.header').outerHeight(),
                breadcrumb_height = $('#breadcrumb').outerHeight(),
                browser_top_area = 115, // Top area with address bar, tabs, menu and shortcuts height in px
                browser_status_bar = 25, // Bottom status bar height in px
                windows_task_bar = 40, // Windows task bar height in px
                max_banner_height = client_height - header_height - breadcrumb_height - browser_top_area - browser_status_bar - windows_task_bar,
                min_banner_height = 430;

            if (banner_height > max_banner_height) { // banner is to high, fix it
                max_banner_height = max_banner_height < min_banner_height ? min_banner_height : max_banner_height;
                $('#hero-banner .banner-container').css('max-height', max_banner_height);
            } else {
                $('#hero-banner .banner-container').css('max-height', '');
            }
        }
    }

    // Zuklappen des Dropdowns verhindern
    $('.dropdown-menu .dropdown-user-data').click(function(e) {
        e.stopPropagation();
    });

    // Scrollto function
    function scrollToPosition(element) {
        'use strict';
        var breakpoint = jRes.getBreakpoint();
        var offset = 0;
        
        if (breakpoint === 'smartphone') {
            offset = 0;
        }
        $('html, body').stop().animate({
            scrollTop: $(element).offset().top - offset
        }, 1000);
        return false;
    }

    /* Initiate owl-carousel */
    function initiateOwlCarousel(){
        if ($().owlCarousel) {
            if ($('#hero-banner').length) {
                var owlhero = $('#hero-banner'),
                    owlheroloop = true,
                    owlheroautoplay = true,
                    owlherodelay = 6000;

                if (owlhero.find('.banner-container').length > 1) {
                    if (owlhero.attr('data-loop') !== undefined) {
                        owlheroloop = owlhero.attr('data-loop');
                        if (owlheroloop === 'false') {
                            owlheroloop = false;
                        }
                    }
                    if (owlhero.attr('data-autoplay') !== undefined) {
                        owlheroautoplay = owlhero.attr('data-autoplay');
                        if (owlheroautoplay === 'false') {
                            owlheroautoplay = false;
                        }
                    }
                    if (owlhero.attr('data-delay') !== undefined) {
                        if (isNaN(parseInt(owlhero.attr('data-delay'), 10)) === false) {
                            owlherodelay = parseInt(owlhero.attr('data-delay'), 10);
                        }
                    }
                    owlhero.on('initialized.owl.carousel', function(event) {
                        fixBannerHeight(owlhero);
                    }).owlCarousel({
                        items: 1,
                        lazyLoad: true,
                        loop: owlheroloop,
                        mouseDrag: false,
                        nav: true,
                        navText: [],
                        autoplay: owlheroautoplay,
                        autoplayTimeout: owlherodelay,
                        autoplayHoverPause: true,
                        autoplaySpeed: 600,
                        navSpeed: 600,
                        dotsSpeed: 600
                    }).on('changed.owl.carousel resized.owl.carousel', function(event) {
                        var eleheight = owlhero.find('.banner-subtext').eq(event.item.index).outerHeight();
                        fixBannerHeight(owlhero);
                        //owlhero.find('.owl-nav').css('bottom', (eleheight + 75) / 2);
                    }).one('inview', '.owl-nav', function() {
                        //var eleheight = owlhero.find('.active .banner-subtext').eq(0).outerHeight();
                        //$(this).css('bottom', (eleheight + 75) / 2);
                    }).find('.banner-subtext').css('padding-bottom', '35px');
                } else {
                    //setTimeout(function() {
                        // fix for IE und FF with timeout
                        owlhero.show();
                        $('#hero-banner').show();
                    //}, 150);
                }
            }

            if ($('.owl-video-slider').length) {
                var owlvideo = $('.owl-video-slider'),
                    owlvideoloop = true,
                    owlvideodelay = 6000;

                if (owlvideo.find('.item-video').length) {
                    if (owlvideo.attr('data-loop') !== undefined) {
                        owlvideoloop = owlvideo.attr('data-loop');
                        if (owlvideoloop === 'false') {
                            owlvideoloop = false;
                        }
                    }
                    if (owlvideo.attr('data-delay') !== undefined) {
                        if (isNaN(parseInt(owlvideo.attr('data-delay'), 10)) === false) {
                            owlvideodelay = parseInt(owlvideo.attr('data-delay'), 10);
                        }
                    }

                    owlvideo.on('initialized.owl.carousel', function () {
                        $('.owl-video-slider .item-video').each(function () {
                            var poster = $(this).find('a.owl-video').data('poster');
                            if (typeof poster != 'undefined') {
                                $(this).find('.owl-video-tn').css({ 'background-image': 'url(' + poster + ')' });
                            }
                        });
                    }).owlCarousel({
                        items: 1,
                        merge: false,
                        loop: false,
                        margin: 10,
                        video: true,
                        nav: true,
                        navText: [],
                        dots: true,
                        dotsEach: true,
                        lazyLoad: false,
                        center: true,
                        videoWidth: false, // Default false; Type: Boolean/Number
                        videoHeight: false, // Default false; Type: Boolean/Number
                        responsive: {
                            480: {
                                items: 1,
                                videoWidth: false,
                                videoHeight: false
                            },
                            600: {
                                items: 1
                            }
                        }
                    });
                } else {
                    owlvideo.show();
                }
            }


            var owl = $('.owl-teaser'),
                owllenght = owl.length,
                owlloop = false,
                owlautoplay = false,
                owlmerge,
                owlnav = false,
                owlresponsive,
                owlrandom = false,
                owlmousedrag = true,
                i;

            if (owllenght) {
                for (i = 0; i < owllenght; i = i + 1) {
                    owlloop = true;
                    if ($(owl[i]).attr('data-loop') !== undefined) {
                        owlloop = $(owl[i]).attr('data-loop');
                        if (owlloop === 'true') {
                            owlloop = true;
                        }else{
                            owlloop = false;
                        }
                    }
                    if ($(owl[i]).attr('data-nav') !== undefined) {
                        owlnav = $(owl[i]).attr('data-nav');
                        if (owlnav === 'true') {
                            owlnav = true;
                        }else{
                            owlnav = false;
                        }
                    }
                    if ($(owl[i]).attr('data-autoplay') !== undefined) {
                        owlautoplay = $(owl[i]).attr('data-autoplay');
                        if (owlautoplay === 'true') {
                            owlautoplay = true;
                        }else{
                            owlautoplay = false;
                        }
                    }
                    if ($(owl[i]).attr('data-random') !== undefined) {
                        owlrandom = $(owl[i]).attr('data-random');
                        if (owlrandom === 'true') {
                            owlrandom = true;
                        }else{
                            owlrandom = false;
                        }
                    }
                    if ($(owl[i]).attr('data-mousedrag') !== undefined) {
                        owlmousedrag = $(owl[i]).attr('data-mousedrag');
                        if (owlmousedrag === 'false') {
                            owlmousedrag = false;
                        }else{
                            owlmousedrag = true;
                        }
                    }
                    owlresponsive = { '0': { items: 1 }, '480': { items: 2 }, '768': { items: 3 }, '992': { items: 4 } };
                    if ($(owl[i]).attr('data-owl') !== undefined) {
                        if (tryParseJSON($(owl[i]).attr('data-owl'))) {
                            owlresponsive = JSON.parse($(owl[i]).attr('data-owl'));
                        }
                    }
                    owlmerge = false;
                    if ($(owl[i]).find('[data-merge]').length) {
                        owlmerge = true;
                    }
                    $(owl[i]).owlCarousel({
                        onInitialize : function(element){
                            // Randomize elements order
                            if(owlrandom){
                                owl.children().sort(function(){
                                    return Math.round(Math.random()) - 0.5;
                                }).each(function(){
                                    $(this).appendTo(owl);
                                });
                            }
                        },
                        loop: owlloop,
                        mouseDrag: owlmousedrag,
                        merge: owlmerge,
                        autoplay: owlautoplay,
                        autoplayHoverPause: true,
                        slideBy: 1,
                        nav: owlnav,
                        navText: [],
                        responsive: owlresponsive
                    });
                }
                owl.on('resized.owl.carousel', function() {
                    var ele = $(this),
                        eleheight;

                    if (ele.hasClass('owl-content') === false) {
                        setTimeout(function() {
                            eleheight = ele.find('img').eq(0).outerHeight();
                            ele.find('.owl-nav').css('top', (eleheight - 57) / 2);
                        }, 500);
                    }
                    if (ele.hasClass('owl-info')) {
                        var elecon = ele.closest('.teaser-list');

                        elecon.find('.tab-pane.active').removeClass('active').end()
                            .find('.tab-activeicon').addClass('display-none');
                    }
                }).on('changed.owl.carousel', function() {
                    var ele = $(this);

                    if (ele.hasClass('owl-info')) {
                        var elecon = ele.closest('.teaser-list');

                        elecon.find('.tab-pane.active').removeClass('active').end()
                            .find('.tab-activeicon').addClass('display-none');
                    }
                }).one('inview', '.owl-nav', function() {
                    var ele = $(this),
                        eleheight;

                    if (ele.closest('.owl-content').length === 0) {
                        setTimeout(function() {
                            eleheight = ele.closest('.owl-teaser').find('img').eq(0).outerHeight();
                            ele.css('top', (eleheight - 57) / 2);
                        }, 500);
                    }
                });
            }

            var gallery = $('.owl-gallery'),
                gallerylenght = gallery.length,
                imgEle,
                imgElelength,
                imgSrc,
                img,
                x;

            

            if (gallerylenght) {
                for (i = 0; i < gallerylenght; i = i + 1) {
                    imgEle = $(gallery[i]).closest('.gallery-container').find('img[data-gallerysrc]');
                    imgElelength = imgEle.length;
                    imgSrc = [];
                    img = [];

                    galleryInit(i);
                }
                gallery.on('changed.owl.carousel resized.owl.carousel', function(event) {
                    var ele = $(this),
                        eleheight = ele.find('img').eq(event.item.index).outerHeight();

                    ele.find('.owl-nav').css('top', (eleheight - ele.find('.owl-prev').outerHeight()) / 2);
                }).one('inview', '.owl-nav', function() {
                    var ele = $(this),
                        eleheight = ele.closest('.owl-gallery').find('img').eq(0).outerHeight();

                    ele.css('top', (eleheight - ele.find('.owl-prev').outerHeight()) / 2);
                });
            }
        }
    }
    initiateOwlCarousel();

    function galleryLoaded(i, x) {
        $(imgEle[x]).removeAttr('data-gallerysrc').attr('src', imgSrc[x]);

        if (x === (imgElelength - 1)) {
            var gallerycontainer = $(gallery[i]).closest('.gallery-container'),
                gallerydots = true;

            if (gallerycontainer.find('.owl-thumbnail').length) {
                gallerydots = false;
            }

            setTimeout(function() {
                gallerycontainer.find('.gallery-spinner').fadeTo('slow', 0);

                $(gallery[i]).css('opacity', '0').owlCarousel({ // carousel function for image gallery
                    items: 1,
                    autoHeight: true,
                    nav: true,
                    navText: ['<i class="fa fa-angle-left font-xlarge color-white text-shadow" aria-hidden="true"></i>', '<i class="fa fa-angle-right font-xlarge color-white text-shadow" aria-hidden="true"></i>'],
                    navSpeed: 600,
                    dots: gallerydots,
                    dotsSpeed: 600
                }).fadeTo('slow', 1);
                gallerycontainer.removeAttr('style');

                if (gallerydots === false) {
                    gallerycontainer.find('.owl-thumbnail').css('opacity', '0').owlCarousel({ // carousel function for thumbnail slider
                        autoWidth: true,
                        //center: true,
                        nav: false,
                        dots: false
                    }).on('click', '.owl-item', function() {
                        // On click of thumbnail items to trigger same main item
                        $(gallery[i]).trigger('to.owl.carousel', [$(this).index(), 500, true]);

                    }).on('changed.owl.carousel', function(e) {
                        // On change of thumbnail item to trigger main item
                        $(gallery[i]).trigger('to.owl.carousel', [e.item.index, 500, true]);
                    }).fadeTo('slow', 1);

                    $(gallery[i]).on('changed.owl.carousel', function(e) {
                        //On change of main item to trigger thumbnail item
                        gallerycontainer.find('.owl-thumbnail').trigger('to.owl.carousel', [e.item.index, 500, true]);
                    });
                }
            }, 600);
        }
    }

    function galleryInit(i) {
        $(gallery[i]).closest('.gallery-container').one('inview', function(event, isVisible) {
            $(this).height(300).append('<i class="gallery-spinner fa fa-cog fa-spin fa-3x fa-fw font-xlarge center-abs-transform"></i>');

            for (x = 0; x < imgElelength; x = x + 1) {
                imgSrc[x] = $(imgEle[x]).attr('data-gallerysrc');
                img[x] = new Image();
                img[x].onload = galleryLoaded(i, x);
                img[x].src = imgSrc[x];
            }
        });
    }

    /* Lazyload for images with class 'img-lazyload' */
    window.inviewLazyLoad = function(){
        $('img[data-src]').one('inview', function(event, isVisible) {
            if (!isVisible) {
                return;
            }
            var element = $(this),
                imgSrc = element.attr('data-src'),
                img = new Image();
            // define what happens once the image is loaded.
            img.onload = function() {
                element.removeAttr('data-src');
                if (element.hasClass('js-inview-anim')) {
                    element.css({ 'padding-bottom': '0', 'opacity': '0' }).attr('src', imgSrc).fadeTo(350, 1, function() {
                        element.css('opacity', '').removeAttr('style');
                    });
                } else {
                    element.attr('src', imgSrc).removeAttr('style');
                }
            };
            // The onload function will now trigger once it's loaded.
            img.src = imgSrc;
        });
    };
    inviewLazyLoad();
    

    /* Initiate animate on elements */
    function initiateJsAnimated(){
        $('.js-animated').on('inview', function(event, isVisible) {  // hier nicht mit body arbeiten, da sonst immer wenn eins sichtbar, alle sichtbar werden!
            if (!isVisible) {
                return;
            }
            var element = $(this),
                animtype = element.attr('data-anim'),
                animinitial = element.attr('data-animinitial'),
                animdelay = parseInt(element.attr('data-animdelay'), 10),
                animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
            if (isNaN(animdelay)) {
                animdelay = 0;
            }
            setTimeout(function() {
                if (animtype === undefined) {
                    element.removeClass('js-animated');
                }
                if (animinitial !== undefined) {
                    animtype = animinitial;
                    element.removeAttr('data-animinitial');
                }
                element.removeClass('opacity-zero').addClass('animated ' + animtype).one(animationEnd, function() {
                    $(this).removeClass('animated ' + animtype);
                });
            }, animdelay);
        });
    }
    initiateJsAnimated();

    /* Display or hide elements on mobile devices */
    window.handleMobileElementsVisibility = function(){
        if (isMobile.android()) {
            $('.hidden-mobileos').hide();
            $('.visible-android').show();
            userAgent = 'android';
        } else if (isMobile.blackBerry()) {
            $('.hidden-mobileos').hide();
            $('.visible-blackberry').show();
            userAgent = 'blackberry';
        } else if (isMobile.windows()) {
            $('.hidden-mobileos').hide();
            $('.visible-windows').show();
            userAgent = 'windows';
        } else if (isMobile.iOS()) {
            $('.hidden-mobileos').hide();
            $('.visible-ios').show();
            userAgent = 'ios';
        }
        
        if (isMobile.any()) {  // is a mobile
            $('.visible-mobileos').show();
            // $('.visible-mobileos').show();
            // $('.visible-webos').hide();
        } else {  // not a mobile
            //$('.visible-mobileos').show();
            // $('.visible-webos').show();
            // $('.visible-mobileos').hide();
        }
    };
    handleMobileElementsVisibility();

    if($('.js-browser-extension-check').length){
        var browser_name = browser();
        
        switch(browser_name) {
            case 'Chrome':
                $('.js-browser-extension-check').removeClass('display-none');
                $('.js-browser-extension-chrome').removeClass('display-none');
                break;
            case 'Firefox':
                $('.js-browser-extension-check').removeClass('display-none');
                $('.js-browser-extension-firefox').removeClass('display-none');
                break;
            default:
                $('.js-browser-extension-check').addClass('display-none');
        }
    }

    /* Inititate Accordions */
    (function() {
        var i,
            elements = $('a.accordion-headline'),
            elementslength = elements.length;

        // Close all Accordions which haven't class 'active'
        for (i = 0; i < elementslength; i = i + 1) {
            if ($(elements[i]).hasClass('active') === false) {
                $(elements[i]).find('.accordion-arrow').removeClass('fa-angle-up').addClass('fa-angle-down').end()
                    .next('div.accordion-txt').hide().removeClass('active');
            }
        }
        // Add click event to all Accordions
        $(document).on("click", "a.accordion-headline", function(e) {
            var element = $(this);
            var parent = element.closest('.accordion-container');

            if (element.hasClass('active')) {
                element.removeClass('active').find('.accordion-arrow').removeClass('fa-angle-up').addClass('fa-angle-down').end()
                    .next('div.accordion-txt').slideUp('fast').removeClass('active');
            } else {
                // in single accordion only one accordion can be open at once
                if(parent.hasClass('is-single-accordion')){
                    parent.find('div.accordion-txt').slideUp('fast').removeClass('active');
                    parent.find('.accordion-headline').removeClass('active');
                }

                element.addClass('active').find('.accordion-arrow').removeClass('fa-angle-down').addClass('fa-angle-up').end()
                    .next('div.accordion-txt').slideDown('fast').addClass('active');
            }
            
            e.preventDefault();
            $(".tooltipstered.form-error").tooltipster("hide");
        });
    }());
    
    /* Initiate Tabs */
    // Tabs on Info-Slider
    if ($('.owl-info').length) {
        $('body').on('touchstart mouseenter click', '.owl-info a', function(e) {
            var tab = $(this),
                tabcon = tab.closest('.teaser-list'),
                tabactive = tabcon.find('.owl-item.active'),
                tabiconleft = ((100 / tabactive.length) * (tabactive.index(tab.closest('.owl-item')) + 1)) - ((100 / tabactive.length) / 2) - 1,
                reference = $(tab.attr('href')).find('a.btn'),
                referencetarget = reference.attr('target');

            tabcon.find('.tab-activeicon').removeClass('display-none').css('left', tabiconleft + '%');
            if (e.type === 'mouseenter') {
                reference.hide();
            } else if (e.type === 'click' && reference.length) {
                if (referencetarget === undefined) {
                    referencetarget = '_self';
                }
                window.open(reference.attr('href'), referencetarget);
            } else {
                reference.show();
            }
            tab.tab('show');
            e.preventDefault();
        });
    }


    /* Trigger ScrollTo if url hash value matches element or if anchor href id page anchor */
    (function() {
        var urlhash = location.hash.replace('#', ''),
            hashele,
            scrollele = '#' + urlhash,
            breakpoint = jRes.getBreakpoint();

        // Check if url hash matches with an Accordion and set class 'active' and scroll to it, remove class 'active' from all other Accordions
        if (urlhash !== '') {
            if ($('#' + urlhash).length) {
                hashele = $('#' + urlhash);
            } else if ($('[name="' + urlhash + '"]').length) {
                hashele = $('[name="' + urlhash + '"]');
                scrollele = '[name="' + urlhash + '"]';
            }
            if (hashele !== undefined) {
                if (hashele.hasClass('accordion-headline') && hashele.hasClass('active') === false) {
                    //$('a.accordion-headline').removeClass('active');
                    hashele.addClass('active').find('.accordion-arrow').removeClass('fa-angle-down').addClass('fa-angle-up').end()
                        .next('.accordion-txt').show();
                }
                if (hashele.hasClass('tab-pane')) {
                    if (breakpoint === 'smartphone') {
                        if ($('a.accordion-headline[href="#' + urlhash + '"]').hasClass('active') === false) {
                            $('a.accordion-headline[href="#' + urlhash + '"]').click();
                        }
                    }
                    scrollele = $('a[href="#' + urlhash + '"]');
                }
                setTimeout(function() {
                    scrollToPosition(scrollele);
                }, 500);
            }
        }
    }());

    $('body').on('click', 'a[href^="#"]', function(e) {
        var element = $(this),
            elementhash = element.attr('href').replace('#', ''),
            hashelement,
            scrollelement = '#' + elementhash,
            breakpoint = jRes.getBreakpoint();

        if (element.attr('role') !== 'tab' && element.hasClass('accordion-headline') === false && elementhash.length > 1) {
            if ($('#' + elementhash).length) {
                hashelement = $('#' + elementhash);
            } else if ($('[name="' + elementhash + '"]').length) {
                hashelement = $('[name="' + elementhash + '"]');
                scrollelement = '[name="' + elementhash + '"]';
            }
            if (hashelement !== undefined) {
                e.preventDefault();
                if (hashelement.hasClass('accordion-headline') && hashelement.hasClass('active') === false) {
                    //$('a.accordion-headline').removeClass('active');
                    hashelement.addClass('active').find('.accordion-arrow').removeClass('fa-angle-down').addClass('fa-angle-up').end()
                        .next('.accordion-txt').show().addClass('active');
                }
                if (hashelement.hasClass('tab-pane')) {
                    if (breakpoint === 'smartphone') {
                        if ($('a.accordion-headline[href="#' + elementhash + '"]').hasClass('active') === false) {
                            $('a.accordion-headline[href="#' + elementhash + '"]').click();
                        }
                    } else {
                        scrollelement = '#js-' + elementhash;
                        $(scrollelement).click();
                    }
                }
                setTimeout(function () {
                    scrollToPosition(scrollelement);
                    element.blur();
                }, 500);
                
            }
        }
    });


    /* Trigger functions based on breakpoints */
    jRes.addFunc([{
        breakpoint: 'smartphone',
        enter: function() {
            // Hide Footer Linklist and bind onclick function
            $('#footer .sitemap-title').on('click', function() {
                var element = $(this),
                    elementlist = element.next('ul');

                if (elementlist.hasClass('active')) {
                    element.find('.sitemap-arrow').removeClass('fa-angle-up').addClass('fa-angle-down');
                    elementlist.removeClass('active').slideUp();
                } else {
                    element.find('.sitemap-arrow').removeClass('fa-angle-down').addClass('fa-angle-up');
                    elementlist.addClass('active').slideDown();
                }
            }).next('ul').slideUp();
        },
        exit: function() {
            // Show Footer Linklist and remove onclick function
            $('#footer .sitemap-title').off('click').find('.sitemap-arrow').removeClass('fa-angle-up').addClass('fa-angle-down').end()
                .next('ul').removeClass('active').removeAttr('style');
        }
    }]);


    /* Set same height for each element with attribute data-sameheight */
    function setSameheight(ele) {
        var breakpoint = jRes.getBreakpoint();
        var heighest = 0;

        if (breakpoint === 'smartphone') {
            $(ele).removeAttr('style');
        }else{
            if($(ele).hasClass('js-sameheight-in-row')){  // if class set, sameheight will calculated for items in each row!
                if($(ele).closest('.row').length && $(ele).closest('.row').find('[class^=col-]').length > 1){
                    var elements_in_a_row = 1;
                    var count_elem_cols = $(ele).closest('.row').find('[class^=col-]').length;
                    var container_width =  Math.floor($(ele).closest('.row')[0].getBoundingClientRect().width);  // FF liefert bei 33% Col-width 366.667, Chrome und IE 366.656, daher vorher abrunden
                    var $elem_col = $(ele).closest('div [class^=col-]');
                    var elem_col_width = Math.floor($elem_col[0].getBoundingClientRect().width);  // FF liefert bei 33% Col-width 366.667, Chrome und IE 366.656, daher vorher abrunden
    
                    elements_in_a_row = Math.floor(container_width / elem_col_width);
    
                    var last_elem_index_loop = 0;
                    $(ele).each(function (i) {
                        i++;
                        var $element = $(this);
        
                        $element.css("height", "auto");
                        if ($element.height() > heighest) {
                            heighest = $element.height();
                        }

                        if(i == count_elem_cols){
                            $(ele).slice(last_elem_index_loop, i).height(heighest);
                            return false;
                        }

                        if(i % elements_in_a_row == 0){
                            $(ele).slice(i-elements_in_a_row, i).height(heighest);
                            heighest = 0;
                            last_elem_index_loop = i;
                        }
                    });
                }
            }else{
                $(ele).each(function () {
                    var $element = $(this);
        
                    $element.css("height", "auto");
                    if ($element.height() > heighest) {
                        heighest = $element.height();
                    }
                });
                $(ele).height(heighest);
            }
        }
    }

    function resizeSameheight() {
        var sameheight = $("[data-sameheight]"),
            sameheightclass = [],
            i;

        for (i = 0; i < sameheight.length; i = i + 1) {
            sameheightclass.push($(sameheight[i]).attr("data-sameheight"));
        }
        sameheightclass = $.uniqueSort(sameheightclass);
        for (i = 0; i < sameheightclass.length; i = i + 1) {
            setSameheight(sameheightclass[i]);
        }
    }
    
    if ($("[data-sameheight]").length) { 
        (function () {
            var resizetimer;

            $(window).on("resize", function () {
                clearTimeout(resizetimer);
                resizetimer = setTimeout(resizeSameheight, 250);
            });

            //setTimeout(function() {
                resizeSameheight();
            //}, 250);
        }());
    }


    // on modal scroll, update tooltipster position
    $('.modal').on('scroll', function(){
        $(this).find('.tooltipstered').tooltipster('reposition');
    });
    

    /* Initiate tooltipster and assign to all existing tooltips */
    function initiateTooltipster(){
        //$(".tooltipstered").tooltipster('destroy');
        if ($().tooltipster) {
            // Trigger info
            if ($('.js-tooltip-forminfo:not(.tooltipstered)').length) {
                $('.js-tooltip-forminfo:not(.tooltipstered)').tooltipster({
                    functionInit: function (origin, content) {
                        var tooltipcontent = $(origin).parent().find('.js-tooltip-text').html();

                        if (tooltipcontent !== undefined && tooltipcontent !== '') {
                            return tooltipcontent;
                        }
                    },
                    functionReady: function (origin, content) {
                        if (typeof Updater != 'undefined') {
                            Updater.setCkEditor(content);
                        }
                    },
                    contentAsHTML: true,
                    //repositionOnScroll: true,
                    interactive: true,
                    contentCloning: false,
                    trigger: 'click',
                    delay: 200,
                    multiple: true,
                    maxWidth: 380,
                    theme: 'tooltipster-black',
                    position: 'top',
                    speed: 200
                });
            }
        
            $(document).on('mouseenter', '.tooltip:not(.tooltipstered)', function(){
                $(this).tooltipster({ 
                    theme: 'tooltipster-default',
                    contentAsHTML: true,
                    animation: 'grow',
                    delay: 200
                }).tooltipster('show');
            });
        
            $(document).on('mouseenter', '.tooltip-black:not(.tooltipstered)', function(){
                var timer = 0;

                if(!$(this).hasClass('tooltip-only-mobile') || ($(this).hasClass('tooltip-only-mobile') && isMobile.any())){
                    if($(this).hasClass('tooltip-show-hide')){
                        timer = 750;
                    }

                    $(this).tooltipster({ 
                        theme: 'tooltipster-black',
                        contentAsHTML: true,
                        animation: 'fade',
                        delay: 200,
                        timer: timer
                    }).tooltipster('show');
                }
            });
            

            /* Initiate tooltipster custom trigger class */
            $('.js-custom-trigger-tooltip:not(.tooltipstered)').tooltipster({
                functionBefore: function (origin, continueTooltip) {
                    var tooltip = $(origin);

                    continueTooltip();

                    if (tooltip.closest(".modal-content").length) {
                        $(".tooltipster-black").css("z-index", "8030");
                    }
                },
                theme: "tooltipster-black",
                animation: 'fade',
                animationDuration: 100,
                delay: 0,
                trigger: 'custom',
                distance: 6,
                interactive: true
            });
        }
    }
    initiateTooltipster();

    /* Function to show and hide tooltipster */
    function showHideTooltipster(btn, tooltip_text) {
        $(btn).tooltipster("content", tooltip_text).tooltipster("show");
        setTimeout(function () {
            $(btn).tooltipster("hide");
        }, 750);
    }

    /* Clipboard success error function */
    var clipboard = new Clipboard('.js-copy-clipboard');
    clipboard.on('success', function (e) {
        var tooltip_text = $(e.trigger).attr('data-text-copied-message');
        showHideTooltipster(e.trigger, tooltip_text);
        e.clearSelection();
    });

    
    /* loading button on click */
    $('body').on('click', '.btn.btn-loading', function(e) {
        var btn = $(this);
        if ($().validate && $(".form-general").length) {
            if(btn.closest(form).valid()){  // show loading only, if closest formular is valid!
                btn.button('loading');
                // commented 18.11.2017
                // setTimeout(function() {
                //     btn.button('reset');
                // }, 2000);
            }
        }
    });

    // slider function
    if ($('#slider').length) {
        var $slider = $("#slider");
        var $output = $("#js-results-per-page");
        var $output_input = $("#js-results-per-page-input");

        // Update the current slider value (each time you drag the slider handle)
        $slider.on('input', function(){
            $output_input.val($(this).val());
            $output.text($(this).val());
        });
    }
	
	/* TOOLTIP FOR ALL SITES STARTS */
	$(".cust_tooltip").tooltip({
		// place tooltip on the right edge
		position: "center right",
		// a little tweaking of the position
		offset: [-2, 10],
		// use the built-in fadeIn/fadeOut effect
		effect: "fade",
		// custom opacity setting
		opacity: 0.7,
		// select an other class
		tipClass: 'input_tooltip'
	});
	/* TOOLTIP FOR ALL SITES ENDS */
	
	$('.mail_link').click(function(e){
		e.preventDefault();
		var mail_value = $(this).attr('data-mail');
		mailDecryptLink(mail_value);
	});

    $('.js-auto-post').change(function(){
        var trigger_btn = $(this).data('autoclick-input');  // have to be an id in data-attribute
        $('#' + trigger_btn).trigger('click'); 
    });

    $('.js-trigger-click-id').click(function(){
        var trigger_id = $(this).data('trigger-id');  // have to be an id in data-attribute
        $('#' + trigger_id).closest('form').trigger('submit');
        $('#' + trigger_id).trigger('click');
    });

    if($('.js-trigger-click-id-on-load').length){
        var trigger_id = $('.js-trigger-click-id-on-load').data('trigger-id');  // have to be an id in data-attribute
        setTimeout(function () {
            $('#' + trigger_id).trigger('click');
        }, 650);  // nicht zu kurz, sonst wird die zuerst aufgerufene Seite nicht in der History gespeichert. #swal steht dort aber bei back geht der Browser zu bzw. auf die leere Seite! 17.11.2024 - von 400 auf 650 erhöht, weil bei Android manchmal das in App anlegen Overlay bei Wunschzettel anlegen beim Schließen auf die vorherige Seite ging. Der Hash legt beim Öffnen einen History Eintrag an!
    }
    
    $('body').on('change', '.js-image-upload-preview', function (e) {
        var $preview_elem = $($(this).data('preview-element'));
        $preview_elem.empty();

        if ($().validate && $(".form-general").length) {
            if ($(this).valid()) {
                if (this.files && this.files[0]) {
                    loadImage(
                        e.target.files[0],
                        function (img, data) {
                            $preview_elem.html(img);
                        },
                        { 
                            maxWidth: 200,
                            maxHeight: 200,
                            //orientation: true
                        }
                    );
                }
            }
        }
    });


    $('body').on('change input', '#geschenk-suche :input', function (e) {
        $(".tooltipstered.form-error").tooltipster("hide");
    });
    
    // when BS Tab shown
    $('body').on('hide.bs.tab', 'a[data-toggle="tab"]', function (e) {
        $(".tooltipstered.form-error").tooltipster("hide");
    });

    /* nav-tabs hash in url schreiben */
    $('body').on('click', '.nav-tabs.js-hash-tabs a', function (e) {
        e.preventDefault();
        $(this).tab('show');
      });
      
    // store the currently selected tab in the hash value
    $('body').on('shown.bs.tab', 'ul.nav-tabs.js-hash-tabs > li > a', function (e) {
        var id = $(e.target).attr("href").substr(1);
        var element_id = $(e.target).attr("id");
        if(history.pushState) {  // change hash, on if pushState available in browser
            history.pushState(null, null, '#' + id);
        }
    });
    /* nav-tabs hash in url schreiben:end */


    // validate fileupload field on change
    $('body').on('change', 'input[type="file"].validate-upload', function (e) {
        $(this).valid();
	});

    $('body').on('show.bs.modal', '.modal', function (event) {
        //var modal_id = $(event.target).attr('id'); // target element id 
        window.location.hash = "modal";
        if($('#pageup').hasClass('active')){
            $('#pageup').removeClass('active');
        }

        // verstecke alle Tooltipster Fehler
        $(".tooltipstered").tooltipster("hide");
    });

    $(window).on('hashchange', function (event) {
        if(window.location.hash != "#modal" && window.location.hash != "#swal") {
            $(".modal").modal('hide');
        }
    });

    // when modal opened, focus on first input
    $('body').on('shown.bs.modal', '.modal', function (event) {
        var modal_id = $(event.target).attr('id'); // target element id 
        var breakpoint = jRes.getBreakpoint();
        if(!$(this).hasClass('dont-autofocus')){
            $('input:visible:enabled:first', this).focus();
        }

        // verstecke alle Tooltipster Fehler
        $(".tooltipstered").tooltipster("hide");
        
        // Wenn Geschenk Suche, dann Funktion ausführen
        if($(this).find('#geschenk-suche:visible').length){
            setTimeout(function() {  // etwas warten, bis der Content reingeladen wurde, um dann die Checks durchzuführen
                checkRelatedElementsGeschenksuche();
            }, 250);
        }

        if(!$(this).find('.tab-content .tab-pane.active').length && breakpoint !== 'smartphone'){
            //hier kann man standardmäßig einen Tag öffnen, wenn nicht Smartphone
            //$('.nav-tabs .js-geschenk-suche').trigger('click');
        }
    });

    $('body').on('hide.bs.modal', '.modal', function (e) {
        $(this).find(".tooltipstered.form-error").tooltipster("hide");

        if(window.location.hash == "#modal") {
            window.history.back();
        }
    });

    $('body').on('hidden.bs.modal', '.modal', function (e) {
        $(this).removeData('bs.modal');
        // die Tooltipster werden nicht immer im hide.bs.modal versteckt! Daher hier nochmal!
        $(this).find(".tooltipstered.form-error").tooltipster("hide");
    });

    // 29.05.2021 - nach dem Schließen soll der Modal Content entfernt werden, damit es nicht zu dem unschönen Effekt kommt, dass der zuletzt gezeigte Content kurz aufscheint
    $('body').on('hidden.bs.modal', '#addwish', function (e) {
        //$(this).removeData('bs.modal');
        $(this).find('#modal-content').empty();
    });

    // This event is fired when the modal has loaded content using the remote option
    $('body').on('loaded.bs.modal', '.modal', function () {
        validateAllForms($(this));
        initiateTooltipster();  // benötigt etwas timeout, da validateAllForms vorher alle Tooltipster löscht.
    });

    // Dropdown Fix
    $('body').on('shown.bs.dropdown', '.dropdown', function (e) {
        // calculate the required sizes, spaces
        var $ul = $(this).find(".dropdown-menu");
        var $button = $(this).find(".dropdown-toggle");
        var ul_offset = $ul.offset();
        var window_height = $(window).height();
        if($('body').hasClass('is-app')){
            window_height = window_height - 50; // in app we have fixed footer 50px height
        }
        // how much space would be left on the top if the dropdown opened that direction
        var space_up = (ul_offset.top - $button.height() - $ul.height()) - $(window).scrollTop();
        // how much space is left at the bottom
        var space_down = $(window).scrollTop() + window_height - (ul_offset.top + $ul.height());
        // switch to dropup only if there is no space at the bottom AND there is space at the top, or there isn't either but it would be still better fit
        if (space_down < 0 && (space_up >= 0 || space_up > space_down))
          $(this).addClass("dropup");
    }).on("hidden.bs.dropdown", ".dropdown", function() {
        // always reset after close
        $(this).removeClass("dropup");
    });

    // scroll to top function
    if ($('#pageup').length) {
        (function(){
            var pageup = $('#pageup');
            var lastScrollTop = 0;
            var delta = 250;  // px to scroll before show header

            $('body').on('click', '#pageup', function(e) {
                e.preventDefault();
                var elements = 'html, body';

                // if modal open, scroll top modal
                if ($('.modal').is(':visible')) {
                    elements = '.modal';
                }

                $(elements).stop().animate({
                    scrollTop: 0
                }, 1000, function(){
                    $('#pageup').blur();
                    $('#pageup').unbind('mouseenter mouseleave');
                });
            });

            function calculateIfShowPageup(fromTop){
                if(fromTop < 200){
                    pageup.removeClass('active');
                }else{
                    if (fromTop > lastScrollTop){
                        // downscroll code
                        pageup.removeClass('active');
                    } else {
                        if(Math.abs(lastScrollTop - fromTop) <= delta){
                            return;
                        }
                        // upscroll code
                        pageup.addClass('active');
                    }
                }

                lastScrollTop = fromTop;
            }

            $(window).scroll(function(event){
                var fromTop = $(window).scrollTop();
                calculateIfShowPageup(fromTop);
            });

            $('#addwish').scroll(function(event){
                var fromTop = $(this).scrollTop();
                calculateIfShowPageup(fromTop);
            });
        })();
    }

    if ($('.js-add-wish-plus').length) {
        $('#pageup').addClass('page-has-plus-button');
    }

    // fix for scrolltop animations
    $('body,html').bind('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function(e){
        if ( e.which > 0 || e.type == "mousedown" || e.type == "mousewheel" || e.type == "touchmove"){
            $("html,body").stop();
        }
    });

    //plugin bootstrap minus and plus
    //http://jsfiddle.net/laelitenetwork/puJ6G/
    /* aktuell nicht verwendet 
    $('.btn-number').click(function (e) {
        e.preventDefault();

        var fieldName = $(this).attr('data-field');
        var type = $(this).attr('data-type');
        var input = $("input[name='" + fieldName + "']");
        var currentVal = parseInt(input.val());
        if (!isNaN(currentVal)) {
            if (type == 'minus') {
                if (currentVal > input.attr('min')) {
                    input.val(currentVal - 1).change();
                }
                if (parseInt(input.val()) == input.attr('min')) {
                    $(this).attr('disabled', true);
                }
            } else if (type == 'plus') {
                if (currentVal < input.attr('max')) {
                    input.val(currentVal + 1).change();
                }
                if (parseInt(input.val()) == input.attr('max')) {
                    $(this).attr('disabled', true);
                }
            }
        } else {
            input.val(0);
        }
    });
    $('.input-number').focusin(function () {
        $(this).data('oldValue', $(this).val());
    });
    $('.input-number').change(function () {
        var minValue = parseInt($(this).attr('min'));
        var maxValue = parseInt($(this).attr('max'));
        var valueCurrent = parseInt($(this).val());

        name = $(this).attr('name');
        if (valueCurrent >= minValue) {
            $(".btn-number[data-type='minus'][data-field='" + name + "']").removeAttr('disabled');
        } else {
            alert('Sorry, the minimum value was reached');
            $(this).val($(this).data('oldValue'));
        }
        if (valueCurrent <= maxValue) {
            $(".btn-number[data-type='plus'][data-field='" + name + "']").removeAttr('disabled');
        } else {
            alert('Sorry, the maximum value was reached');
            $(this).val($(this).data('oldValue'));
        }
    });
    $(".input-number").keydown(function (e) {
        // Allow: backspace, delete, tab, escape, enter and .
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    });
    */

    $('body').on('shown.bs.collapse', '.collapse', function (e) {
        var $clickedBtn = $(e.target).data('bs.collapse').$trigger;

        if ($clickedBtn.hasClass('js-hide-on-collapse-shown')){
            $clickedBtn.hide();
        }

        if ($clickedBtn.hasClass('js-collapse-read-more')){
            $clickedBtn.closest('.read-more-container').addClass('more-opened');
        }
    });

    $('body').on('hidden.bs.collapse', '.collapse', function (e) {
        var $clickedBtn = $(e.target).data('bs.collapse').$trigger;

        if ($clickedBtn.hasClass('js-collapse-read-more')){
            $clickedBtn.closest('.read-more-container').removeClass('more-opened');
        }
    });


    // btn-groups with collapse
    $('body').on('click', '.js-btn-group-tabs button', function(e) {
        if(!$(this).hasClass('active')){
            var target_id = $(this).data('target-id');

            $('.js-btn-group-tabs button').each(function () {
                var $element = $(this);
                var each_target_id = $element.data('target-id');

                $element.removeClass('active');
                $('#'+each_target_id).removeClass('in');
            });

            $(this).addClass('active').trigger('blur');
            $('#'+target_id).addClass('in');
        }
    });

    $('body').on('click', '.js-btn-toggle .btn', function(e) {
        e.preventDefault();

        if(!$(this).hasClass('active')){
            $(this).closest('.js-btn-toggle').find('.btn-ghost-black').removeClass('btn-ghost-black active').addClass('btn-default');
            $(this).removeClass('btn-default').addClass('btn-ghost-black active');
            $('.js-btn-toggle-value').val($(this).data('input-value'));
        }
    });
    /************************************************* General functions ENDS *************************************************/


    /************************************************* Wishbob functions STARTS *************************************************/
    $('body').on('click', '.js-submit-wish', function(e) {
        var postData = new FormData($("#form-add-wish")[0]);
        var $this_btn = $(this);
        var wunschliste = $(this).data('wishlist');
        var id = $(this).data('wish-id');
        e.preventDefault();

        if (form.valid()) {
            $.ajax({
                type:'POST',
                url:'/wunsch/bearbeiten/wunschzettel/'+wunschliste+'/id/'+id+'?tab=geschenk-eintragen',
                processData: false,
                contentType: false,
                data : postData,
                //timeout: 6000
                //dataType: 'json',
            }).done(function (data) {
                // hier ist data ein json String, daher wandeln wir es in ein Json Objekt um
                var unpackArr = JSON.parse(data);

                if(unpackArr.status == 'success'){
                    reloadWishes(data, wunschliste, true, true);
                }else{
                    $('.js-add-wish-validation-errors').removeClass('display-none').html(unpackArr.validation_messages);
                    $('#addwish').animate({ scrollTop: 0 }, 'slow');
                    $this_btn.button('reset');
                }
            }).fail(function () {
                showNotify(lang_ajax_save_error_text, 'error');
            });
        }else{
            //  not valid
        }
    });


    $('body').on('show.bs.modal', '#addwish', function (e) {
        var link = $(e.relatedTarget);
        $(this).find(".modal-content").load(link.attr("data-href"), function(response, status, xhr){
            if (status != 'error') {
                $(this).trigger('loaded.bs.modal');  // manuell triggern, da nicht mehr remote Option verwendet wird
                inviewLazyLoad();  // damit die LazyLoad Images hier bei nachgeladenem Content auch funktionieren.

                $('.app-modal .modal-body').scroll(function(event){
                    $(this).find('.tooltipstered').tooltipster('reposition');
                });
            }else{
                // Wenn Modal Inhalt nicht geladen werden kann, dann am besten die ganze Seite neu laden!
                $(this).modal('hide');  // vorher Modal schließen, damit auch #addwish verschwindet.
                setTimeout(function(){ 
                    location.reload();
                }, 350);
            }
        });
    });
    
    $('body').on('click', '.js-delete-wish', function(e) {
        var id = $(this).data('wish-id');
        var wishlist_url_hash = $('.wishlist-wrapper').data('wishlist-hash');
        var swal_title = $(this).data('swal-title');
        var swal_text = $(this).data('swal-text');
        var swal_success_text = $(this).data('swal-success-text');
        var swal_error_text = $(this).data('swal-error-text');

        CustomHashSwal.fire({
            title: swal_title,
            text: swal_text,
            showCancelButton: true,
            confirmButtonText: lang_btn_yes,
            cancelButtonText: lang_btn_no
        }).then(function (result) {
            if (result.value) {
                $.ajax({
                    url: "/wunsch/loeschen/id/"+id,
                }).done(function(data){
                    //$('#wunsch_'+id).addClass('animated lightSpeedOut');
                    $('#wunsch_'+id).animate({
                        width: "toggle",
                        height: "toggle"
                    }, {
                        duration: 200,
                        complete: function() {
                            showNotify(swal_success_text, 'success');
                            resizeSameheight();  // damit werden die Boxen werden neu berechnet!
                            reloadUserStats(wishlist_url_hash);
                            $('#wunsch_'+id).remove();
                            /* don't need it here
                            sortableWishes();
                            */
                        }
                    });
                }).fail(function() {
                    showNotify(swal_error_text, 'error');
                });
            }
        });
    });

    $('body').on('click', '.js-reset-wish-marks', function(e) {
        var id = $(this).data('wish-id');
        //var wishlist_url_hash = $('.wishlist-wrapper').data('wishlist-hash');
        var swal_title = $(this).data('swal-title');
        var swal_text = $(this).data('swal-text');
        var swal_success_text = $(this).data('swal-success-text');
        var swal_error_text = $(this).data('swal-error-text');

        CustomHashSwal.fire({
            title: swal_title,
            text: swal_text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: lang_btn_yes,
            cancelButtonText: lang_btn_no
        }).then(function (result) {
            if (result.value) {
                $.ajax({
                    url: "/wunsch/reset_marks/id/"+id,
                }).done(function(data){
                    $('#wunsch_'+id).addClass('animated pulse').delay(1000).queue(function(){
                        $(this).removeClass("animated pulse").dequeue();
                    });
                    showNotify(swal_success_text, 'success');
                }).fail(function() {
                    showNotify(swal_error_text, 'error');
                });
            }
        });
    });
    

    $('body').on('click', '.js-mark-wish-bought', function(e) { //vorher change statt klick       
        e.preventDefault();
        var wish_id = $(this).data('wish-id');
        MarkWishBought(wish_id);
    });

    function MarkWishBought(wish_id){
        var anzahl = 1; /*this.value; */
        var id = wish_id;
        var wishlist_url_hash = $('.wishlist-wrapper').data('wishlist-hash');
        var swal_title = $('#js-mark-wish-bought-texts').data('swal-title');  // Wunsch erfüllt?
        var swal_text = $('#js-mark-wish-bought-texts').data('swal-text');  // Hast du den Artikel bereits gekauft?
        var swal_cancel_button_text = $('#js-mark-wish-bought-texts').data('swal-cancel-button-text');  // Nein noch nicht
        var swal_title_already_bought = $('#js-mark-wish-bought-texts').data('swal-already-bought-title');  // Jemand war schneller!
        var swal_title_already_bought_attention = $('#js-mark-wish-bought-texts').data('swal-already-bought-attention-title');  // Hinweis!
        var swal_ajax_error_text = $('#js-mark-wish-bought-texts').data('ajax-error-text');  // Beim Markieren des Wunsches ist ein Fehler aufgetreten!

        CustomHashSwal.fire({
            allowOutsideClick: false,
            allowEscapeKey: false,
            title: swal_title,
            text: swal_text,
            //icon: "info",
            showCancelButton: true,
            focusConfirm: true,
            confirmButtonText: lang_btn_yes,
            cancelButtonText: swal_cancel_button_text
        })
        .then(function (result) {
            if (result.value) {
                clearTimeout(wishStatChangedTimeout);
                
                swal_title =  '';
                swal_text = '';
                var swal_icon = 'warning';
                    
                $.ajax({
                    url: "/wunsch/reservieren/id/" + id + "/wunschzettel/" + wishlist_url_hash,
                    method: "post",
                    data: {
                        'AnzahlReserviert': 1 // anzahl
                    }
                })
                .done(function (response) {
                    $('.js-wishlist-stat-wishes-reserved').text(response.count_bought_wishes);

                    if (response.status == 'success') {
                        showNotify(response.message, 'success', 5000);  // hier etwas länger anzeigen, da Erfolgsmeldung mit längerem Text! default 3s.
                        markItemBought(id, true, function(){
                            // callback function momentan nicht in Verwendung
                            checkWishStatsChanged();
                        });
                    }else{  // status = error
                        swal_text = response.message;

                        if(response.bought_status == 0){
                            swal_title =  swal_title_already_bought_attention;  // Hinweis!
                        }else{
                            swal_title =  swal_title_already_bought;  // Jemand war schneller!
                        }

                        setTimeout(function(){  // a little timeout needed for iOS
                            CustomHashSwal.fire({
                                onBeforeOpen: (function (result) {
                                    // test
                                }),
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                title: swal_title,
                                text: swal_text,
                                icon: swal_icon,
                                iconHtml: '<i class="fa fa-fw fa-exclamation" aria-hidden="true"></i>',
                            })
                            .then(function (result) {
                                if (result.value) {
                                    reloadWishesSimple(function(){
                                        // wenn load function fertig, dann Funktion erneut aufrufen.
                                        checkWishStatsChanged();
                                        showNotify(lang_wishlist_reloaded_text, 'success');
                                    });
                                }
                            });
                        }, 400);
                    }
                })
                .fail(function () {
                    showNotify(swal_ajax_error_text, 'error');  // Beim Markieren des Wunsches ist ein Fehler aufgetreten!
                    checkWishStatsChanged();
                });
            }
        });
    }


    $('body').on('click', '.js-unmark-wish-bought', function(e) { //vorher change statt klick       
        var anzahl = 0; /*this.value; */
        var id = $(this).data('wish-id');
        var wishlist_url_hash = $('.wishlist-wrapper').data('wishlist-hash');
        var swal_title = $('#js-unmark-wish-bought-texts').data('swal-title');  // Rückgängig machen?
        var swal_text = $('#js-unmark-wish-bought-texts').data('swal-text');  // Möchtest du die Markierung rückgängig machen?
        var swal_title_already_bought = $('#js-unmark-wish-bought-texts').data('swal-already-bought-title');  // Jemand war schneller!
        var swal_title_already_bought_attention = $('#js-unmark-wish-bought-texts').data('swal-already-bought-attention-title');  // Hinweis!
        var swal_ajax_error_text = $('#js-unmark-wish-bought-texts').data('ajax-error-text');  // Beim Entfernen der Markierung des Wunsches ist ein Fehler aufgetreten!

        CustomHashSwal.fire({
            allowOutsideClick: false,
            allowEscapeKey: false,
            title: swal_title,
            text: swal_text,
            showCancelButton: true,
            focusConfirm: true,
            confirmButtonText: lang_btn_yes,
            cancelButtonText: lang_btn_cancel
        })
        .then(function (result) {
            if (result.value) {
                if (result.value) {
                    clearTimeout(wishStatChangedTimeout);

                    var swal_title =  '',
                        swal_text = '',
                        swal_icon = 'warning';

                    $.ajax({
                        url: "/wunsch/reservieren/id/" + id + "/wunschzettel/" + wishlist_url_hash,
                        method: "post",
                        data: {
                            'AnzahlReserviert': 0 // anzahl
                        }
                    })
                    .done(function (response) {
                        //reloadUserStats(wishlist_url_hash);
                        $('.js-wishlist-stat-wishes-reserved').text(response.count_bought_wishes);

                        if (response.status == 'success') {
                            showNotify(response.message, 'success');
                            unmarkItemBought(id, true, function(){
                                checkWishStatsChanged();
                            });
                        }else{  // status = error
                            swal_text = response.message;

                            if(response.bought_status == 0){
                                swal_title =  swal_title_already_bought_attention;  // Hinweis!
                            }else{
                                swal_title =  swal_title_already_bought; // Jemand war schneller!
                            }

                            setTimeout(function(){  // a little timeout needed for iOS
                                CustomHashSwal.fire({
                                    onBeforeOpen: (function (result) {
                                        // test
                                    }),
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    title: swal_title,
                                    text: swal_text,
                                    icon: swal_icon,
                                    iconHtml: '<i class="fa fa-fw fa-exclamation" aria-hidden="true"></i>',
                                })
                                .then(function (result) {
                                    if (result.value) {
                                        reloadWishesSimple(function(){
                                            // wenn load function fertig, dann Funktion erneut aufrufen.
                                            checkWishStatsChanged();
                                            showNotify(lang_wishlist_reloaded_text, 'success');
                                        });
                                    }
                                });
                            }, 400);
                        }
                    })
                    .fail(function () {
                        showNotify(swal_ajax_error_text, 'error');
                        checkWishStatsChanged();
                    });
                }
            }
        });
    });

    /* WISHLIST OVERVIEW STARTS */
    function checkOverviewTabActive(){
        if($('.js-wishlists-overview-tabs').length){
            if(storageAvailable('localStorage')){
                var active_wishlist_tab_id = localStorage.getItem('wishlist_overview_active_tab');
                $('.js-wishlists-overview-tabs button[data-target-id='+active_wishlist_tab_id+']').trigger('click');
            }
        }
    }
    checkOverviewTabActive();
    

    // muss außerhalb if Abfrage sein, da nachgeladen werden kann
    $('body').on('click', '.js-wishlists-overview-tabs button', function(e) {
        var target_id = $(this).data('target-id');
        
        resizeSameheight();  // damit werden die Boxen werden neu berechnet!
        if(storageAvailable('localStorage')){
            localStorage.setItem('wishlist_overview_active_tab', target_id);
        }
    });

    $('body').on('click', '.js-delete-friends-wishlist', function(e) {
        var $wish_wrapper = $(this).closest('.wish-wrapper');
        var wishlist_hash = $(this).data('wishlist-hash');
        var swal_title = $(this).data('swal-title');
        var swal_text = $(this).data('swal-text');
        var swal_success_text = $(this).data('swal-success-text');
        var swal_error_text = $(this).data('swal-error-text');

        CustomHashSwal.fire({
            title: swal_title,
            text: swal_text,
            showCancelButton: true,
            confirmButtonText: lang_btn_yes,
            cancelButtonText: lang_btn_no
        }).then(function (result) {
            if (result.value) {
                $.ajax({
                    type:'POST',
                    url:'/json/deleteFriendsWishlist/language/'+page_lang,
                    data : {wishlist: wishlist_hash},
                }).done(function(data){
                    $wish_wrapper.animate({
                        width: "toggle",
                        height: "toggle"
                    }, {
                        duration: 200,
                        complete: function() {
                            showNotify(swal_success_text, 'success');
                        }
                    });
                }).fail(function() {
                    showNotify(swal_error_text, 'error');
                });
            }
        });
    });
    /* WISHLIST OVERVIEW ENDS */

    var timeout = null;
    $('body').on('keyup', '.js-amazon-search', function(e) {
        var keywords = this.value;

        if (e.which === 13) {
            $(this).blur();
            clearTimeout(timeout);
            //checkWishSearchForm();
            $('.js-amazon-search-button').trigger('click');
            return false;
        }
        
        if(keywords.trim() != '' && keywords.trim().length >= 2){
            clearTimeout(timeout);
            timeout = setTimeout(function () {
               //checkWishSearchForm();
               $('.js-amazon-search-button').trigger('click');
            }, 1000);
        }
    });

    $('body').on('click', '.js-amazon-search-button', function(e) {
        e.preventDefault();

        if($('.js-amazon-search-button').attr('data-is-searching-amazon') == 'true'){
            return false;
        }else{
            checkWishSearchForm();
        }
    });

    $("#form-gift-search").submit(function(e){
        e.preventDefault();
    });

    $('body').on('change', '.js-amazon-search-federal-state', function(e) {
        var keywords = $('#keywords').val();
        
        if(keywords.trim() != '')
            checkWishSearchForm();
        
    });

    $('body').on('click', '#AmazonLoadMore', function(e) {
        var keywords = $('#keywords').val(); 
        
        if(keywords.trim() != '')
            callPartnerprogramm(keywords);
    });

    function checkWishSearchForm(){
        var btn = $('.js-amazon-search-button');
        var keywords = $('.js-amazon-search').val();

        if ($().validate && $(".form-general").length) {
            if(!form.valid()){  // wenn Formular nicht valide, dann abbrechen!
                return false;
            }
            $('.js-amazon-search-button').attr('data-is-searching-amazon', false);
        }
        
        if($('.js-amazon-search-button').attr('data-is-searching-amazon') == 'false'){
            $('#page').val(0);
            $('#amazonSearchResponse').html('');

            if(keywords.trim() != ''){
                btn.button('loading');
                callPartnerprogramm(keywords);
            }
        }
    }

    $(document).on('submit', '.js-check-captcha', function(e) {
        e.preventDefault();
        var $this = $(this);
        var recaptcha_website_key = $('#g-recaptcha-response').data('website-key');
        
        if($(this).closest(form).valid()){
            grecaptcha.ready(function() {
                grecaptcha.execute(recaptcha_website_key, {action: 'homepage'})
                    .then(function(token) {
                        $('#g-recaptcha-response').val(token);
                        setTimeout(function(){
                            $(document).off('submit', '.js-check-captcha');
                            $this.submit();
                        }, 200);
                });
            });
        }
    });

    $('body').on('click', '.js-add-amazon-wish', function(e) {
        e.preventDefault();

        var wunschliste = $(this).data('wunschliste');
        var fk_partnerprogramm = $(this).data('fk_partnerprogramm');
        var asin = $(this).data('asin');
        var name = $(this).data('name');
        var url = $(this).data('url');
        var bild = $(this).data('bild');
        var waehrung = $(this).data('waehrung');
        var preis = $(this).data('preis');
        var geschenkidee = $(this).data('geschenkidee');
        var referrer = $(this).data('referrer');
        var btn = $(this);
        var reload_content = $(this).hasClass('js-dont-reload-content') ? false : true;  // auf Geschenkideen Seite, kein Reload!
        var beschreibung;

        // swal kein Wunschzettel
        var $swal_html = $("script[data-template='js-template-no-wishlist-found-create-one']").html();
        $swal_html = $('<div />').html($swal_html);
        var swal_title = $swal_html.find('.template-swal-title').text();
        $swal_html.find('.template-swal-title').remove();
        
        // swal optional angaben
        var $swal_html_optional_infos = $("script[data-template='js-template-add-amazon-wish-optional-infos']").html();
        $swal_html_optional_infos = $('<div />').html($swal_html_optional_infos);
        var swal_title_optional_infos = $swal_html_optional_infos.find('.template-swal-title').text();
        var swal_btn_done = $swal_html_optional_infos.find('.template-swal-btn-done').text();
        $swal_html_optional_infos.find('.template-swal-title, .template-swal-btn-done').remove();

        if(wunschliste == ""){
            CustomHashSwal.fire({
                title: swal_title,
                html: $swal_html,
                showCloseButton: true,
                showConfirmButton: false
            });
            return false;
        }

        // only for geschenkidee edit page
        if(geschenkidee)
        {
            $('#UniqueID').val(asin);
            $('#Preis').val(String(preis).replace('.',','));
            $('#Bezeichnung').val(name);
            $('#URL').val(url);
            $('#Bild').val(bild);
            $('#FK_Partnerprogramm').val(fk_partnerprogramm);
            
            showNotify('Daten erfolgreich geladen', 'success');  // Übersetzen nicht notwendig
            $('#container-gift-search').collapse('hide');
            $('#container-gift-search').on('hidden.bs.collapse', function () {
                scrollToPosition('#form-edit-add-gift-idea');
              });            
        }
        else 
        {
            if(!$(this).hasClass('swal-confirmed')){
                if($('#addwish').hasClass('in')){  // if modal is open
                    $('#addwish').hide();
                }

                CustomHashSwal.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    title: swal_title_optional_infos,
                    confirmButtonText: swal_btn_done,
                    html: $swal_html_optional_infos
                })
                .then(function (result) {
                    if($('#addwish').hasClass('in')){  // if modal is open
                        $('#addwish').show();
                    }
                    $(this).addClass('swal-confirmed');
                    beschreibung = $('#optionale-infos').val();

                    btn.button('loading');

                    $.ajax({
                        type:'POST',
                        url:'/wunsch/bearbeiten/wunschzettel/'+wunschliste,
                        //processData: false,
                        //contentType: false,
                        data : {'do' : 'save', 'asin' : asin, 'fk_partnerprogramm' : fk_partnerprogramm, 'Beschreibung' : beschreibung, 'Name' : name, 'URL' : url, 'BildURL' : bild, 'Waehrung' : waehrung, 'Preis' : preis, 'referrer' : referrer, 'URL_Affilinet' : ''}
                    }).done(function (data) {
                        reloadWishes(data, wunschliste, false, reload_content);
                        $('#wunsch_beschreibung_'+asin).removeClass('swal-confirmed');
                        setTimeout(function(){
                            btn.button('reset');
                            btn.button('complete');
                        }, 500);
                    }).fail(function () {
                        showNotify(lang_ajax_save_error_text, 'error');
                    });
                });
            }
        }
    });

    function callPartnerprogramm(keywords)
    {
        var programm = '';
        var shops = '';
        var arr = [];
        var bundesland = '';

        /* 23.12.2022 - aktuell nicht benötigt!
        if($('#programm1').is(':checked'))
            programm = $('#programm1').val();
        else if($('#programm2').is(':checked')) 
        {
            programm = 'DE';
            if($('#geschenktyp1').is(':checked')) 
                bundesland = $('#bundeslandDE').val();
            $.each($("input[name='shopDE']:visible:checked"), function() {
                arr.push($(this).val());
            });
            shops = arr.join(",");

        }
        else if($('#programm3').is(':checked')) 
        {
            programm = 'AT';
            if($('#geschenktyp1').is(':checked')) 
                bundesland = $('#bundeslandAT').val();
            $.each($("input[name='shopAT']:visible:checked"), function() {
                arr.push($(this).val());
            });
            shops = arr.join(",");
        }
        */
        programm = $('#geschenk-suche input[name="programm"]:checked').val();
        
        var itempage = $('#page').val();
        
        if(itempage == "undefined") 
            itempage = 1;
        
        itempage++;
        
        $('#page').val(itempage);
        var itempagemax = $('#maxPage').val();
        if(itempagemax > 5) 
            itempagemax = 5;

        var originalInhalt = $('#amazonSearchResponse').html();
        $('#amazonSearchResponse').append('<div class="text-center loading-spinner"><i class="fa fa-spinner fa-spin fa-2x color-primary"></i></div>');
        $('#AmazonLoadMore').hide();

        
        $.ajax({
            url: "/wunsch/partnerprogrammSearch",
            method: "post",
            data: {
                'keywords' : keywords,
                'wunschzettel' : $('#wunschliste').val(),
                'programm' : programm,
                'shops' : shops,
                'ItemPage' : itempage,
                'bundesland' : bundesland,
                'geschenkidee' : $('#geschenkidee').val()
            }
        })
        .done(function($data) {
            $('#amazonSearchResponse').append($data);
            $('.loading-spinner').remove();
            $('.js-amazon-search-button').button('reset');
            $('.js-amazon-search-button').attr('data-is-searching-amazon', false);

            if($('#amazonSearchResponse .js-no-results').length){
                $('#AmazonLoadMore').hide();
            }else{
                if(itempage < itempagemax)
                    $('#AmazonLoadMore').show();
            }
        })
        .fail(function() {
            $('.loading-spinner').remove();
            $('.js-amazon-search-button').button('reset');
            $('.js-amazon-search-button').attr('data-is-searching-amazon', false);
            showNotify('Bei der Suche ist ein Fehler aufgetreten. Bitte versuche es erneut!', 'error');
        });
    }


    function reloadWishes(data, wunschliste, close_modal, reload_wishes_content)
    {
        if(tryParseJSON(data))
        {
            var unpackArr = JSON.parse(data);
            var status = unpackArr.status;
            var wish_id = unpackArr.id;
            //var title = unpackArr.title;
            var message = unpackArr.message;
            var insert_update = unpackArr.insert_update;
            
            if (close_modal !== undefined && close_modal === true) {
                $('#addwish').modal('toggle');
            }
        
            showNotify(message, status, 1250);

            if (status == 'success') {  // nur wenn success, weiteren Ajax request machen?
                $.ajax({
                    url: "/"+wunschliste+"/ajax/1",
                })
                .done(function(data) {
                    if (reload_wishes_content !== undefined && reload_wishes_content === true) {
                        var $loaded_content = $(data).find('#user-wishes-wrapper'); 
                        var $loaded_content_wishlist_stats = $(data).find('.user-wishlist-stats');

                        $('#user-wishes-wrapper').replaceWith($loaded_content);
                        $('.user-wishlist-stats').replaceWith($loaded_content_wishlist_stats);
                        sortableWishes();
                    }
                    
                    $('.js-no-wishes-alert').hide();
                    //resizeSameheight();  // damit werden die Boxen werden neu berechnet! 03.06.21 - vermutlich nicht mehr notwendig!
                    if (close_modal !== undefined && close_modal === true) {
                        if(insert_update == 'insert'){
                            scrollToPosition('.js-add-wish-btn');
                        }else{
                            scrollToPosition('#wunsch_' + wish_id);
                            $('#wunsch_' + wish_id).addClass('animated zoomIn');
                            // hier die animated Klassen wieder löschen, da sonst beim Verschieben komisch aussieht!
                            setTimeout(function(){
                                $('#wunsch_' + wish_id).removeClass('animated zoomIn');
                            }, 1100);
                        }
                    }
                })
                .fail(function() {
                    showNotify(lang_ajax_save_error_text, 'error');
                });
            }
        }    
        else
        {
            $('#modal-content').html(data);
        }
    }

    // function to reload the user stats
    function reloadUserStats(wishlist_url_hash){
        $('.user-wishlist-stats').load(' .user-wishlist-stats > *');  // "> *" nimmt alle children von dem gefundenen Element
    }

    // wenn externer Link beim Wunsch angeklickt wird, soll der "als gekauft markieren" Alert angezeigt werden.
    if(!$('.js-add-wish-btn').length){
        $('body').on('click', '.wish:not(.wish-fulfilled) .js-goto-product', function(e) {
            var wish_id = $(this).closest('.wish').data('wish-id');
            setTimeout(function(){  // little timeout needed for iOS; without it, the new windows doesn't open - only swal opens!
                MarkWishBought(wish_id);
            }, 500);
        });
    }

    $('body').on('click', '.js-bookmark-button', function(e) {
        e.preventDefault();
        var swal_question = $(this).data('swal-question');
        var swal_text = $(this).data('swal-text');
        //var swal_img = $(this).data('swal-image');
        CustomHashSwal.fire({
            width: 840,
            title: swal_question,
            showCloseButton: true,
            html: '<p>' + swal_text + '</p>'+
                '<iframe width="780" height="439" style="max-width:100%;" src="https://www.youtube.com/embed/86b5eX3sV-M" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>'
        });
    });

    $('body').on('click', '.js-qrcode-button', function(e) {
        e.preventDefault();
        var swal_question = $(this).data('swal-question');
        var swal_text = $(this).data('swal-text');
        var qrcode_image_path = $(this).data('qrcode-image');
        var qrcode_image_alt_text = $(this).data('alt-text-qrcode-image');
        var qrcode_print_link = $(this).data('qrcode-print-link');
        var qrcode_download_btn_text = $(this).data('qrcode-download-btn-text');
        
        CustomHashSwal.fire({
            title: swal_question,
            html: '<p class="margin-bottom-big">' + swal_text + '</p>'+
                '<img class="img-responsive center-block box-shadowed border-radius" src="'+qrcode_image_path+'" alt="'+qrcode_image_alt_text+'" />'
                + (typeof qrcode_print_link !== 'undefined' ? '<br><a class="btn btn-default" href="'+qrcode_print_link+'" target="_blank"><i class="fa fa-fw fa-download"></i>'+qrcode_download_btn_text+'</a>' : '')
        });
    });

    $('body').on('click', '.js-swal-open-target', function(e) {
        e.preventDefault();
        var swal_title = $(this).data('swal-title');
        var swal_show_confirm_btn = true;
        var swal_width;
        var swal_target = $(this).data('swal-target');
        $(swal_target).find('.tooltipstered').tooltipster('destroy');  // hier zerstören, da sonst kopierter Inhalt und kein nochmaliges Tooltipster!
        var $target_html = $(swal_target).html();

        if (typeof $(this).data('swal-width') !== 'undefined') {
            swal_width = $(this).data('swal-width');
        }

        if(typeof $(this).data('show-confirm-button') !== 'undefined'){
            swal_show_confirm_btn = $(this).data('show-confirm-button');
        }

        CustomHashSwal.fire({
            title: swal_title,
            width: swal_width,
            showConfirmButton: swal_show_confirm_btn,
            showCloseButton: true,
            html: $target_html
        });
        inviewLazyLoad();
    });


    $('body').on('click', '.js-swal-confirm-href', function(e) {
        e.preventDefault();
        var link = $(this).attr('data-href');
        var swal_show_cancel = false;
        var swal_type = $(this).data('swal-type');
        var swal_title = $(this).data('swal-title');
        var swal_text = $(this).data('swal-text');
        var swal_confirm_button_text = lang_btn_yes;
        var swal_confirm_button_color = '#3085d6';
        var swal_cancel_button_text = lang_btn_cancel;
        var swal_focus_on_button = 'confirm';
        var swal_focus_on_confirm = true;
        var swal_focus_on_cancel = false;

        if (typeof $(this).data('swal-show-cancel-button') !== 'undefined') {
            swal_show_cancel = $(this).data('swal-show-cancel-button');
        }
        if (typeof $(this).data('swal-confirm-button-text') !== 'undefined') {
            swal_confirm_button_text = $(this).data('swal-confirm-button-text');
        }
        if (typeof $(this).data('swal-cancel-button-text') !== 'undefined') {
            swal_cancel_button_text = $(this).data('swal-cancel-button-text');
        }
        if (typeof $(this).data('swal-confirm-button-color') !== 'undefined') {
            swal_confirm_button_color = $(this).data('swal-confirm-button-color');
        }
        if (typeof $(this).data('swal-focus-button') !== 'undefined') {
            swal_focus_on_button = $(this).data('swal-focus-button');
            if(swal_focus_on_button == 'confirm'){
                swal_focus_on_confirm = true;
                swal_focus_on_cancel = false;
            }else if(swal_focus_on_button == 'cancel'){
                swal_focus_on_cancel = true;
                swal_focus_on_confirm = false;
            }
        }

        CustomHashSwal.fire({
            title: swal_title,
            //text: swal_text,
            html: swal_text,
            icon: swal_type,
            showCancelButton: swal_show_cancel,
            confirmButtonText: swal_confirm_button_text,
            //confirmButtonColor: swal_confirm_button_color,
            cancelButtonText: swal_cancel_button_text,
            focusConfirm: swal_focus_on_confirm,
            focusCancel: swal_focus_on_cancel
        }).then(function (result) {
            if (result.value) {
                window.location = link;
            }
        });
    });

    $('body').on('change', '#Wunschlistentexte', function(e) {
        $('#Beschreibung').val($(this).val());
    });

    $('body').on('change', '#Beschreibung', function(e) {
        var user_text = $(this).val();
        $('#Wunschlistentexte option:first').val(user_text).prop('selected', true);
    });

    // Formularseite Anlass triggern, um die Anlasstext geladen zu bekommen
    if($('#FK_Wunschtyp').length){
        loadEventTexts();
    }

    $('body').on('change', '#FK_Wunschtyp', function(e) {
        var anlass = $(this).val();
        var $affected_elem = $('.js-select-predefined-design-btn');
        var $info_text_elem = $('.js-design-info');
        var $first_visible_design;
        var first_visible_img_path;
    
        if($('#Wunschlistentexte').length){
            if($('#Wunschlistentexte option:selected').index() > 0){  // wenn nicht eigener Text ausgewählt, dann Beschreibungstext leeren!
                $('#Beschreibung').val('');
            }
        }
        
        loadEventTexts();

        if(anlass == ''){
            $info_text_elem.fadeIn();
        }else{
            $info_text_elem.hide();
        }
        resizeSameheight();

        $affected_elem.each(function () {
            var element = $(this);
            var design = element.data("design");
            var split = design.split("_");
            
            if(split[1] == anlass)
                element.removeClass("hidden");
            if(split[1] != anlass && split[1] != "Sonstiges")
                element.addClass("hidden");
        });

        // ersten sichtbaren Banner als aktiven setzen
        $first_visible_design = $('.js-select-predefined-design-btn:not(.hidden):first');
        first_visible_img_path = typeof $first_visible_design.find('.js-select-predefined-design-img').attr('data-src') !== 'undefined' ? $first_visible_design.find('.js-select-predefined-design-img').attr('data-src') : $first_visible_design.find('.js-select-predefined-design-img').attr('src');
        $('.js-selected-predefined-design-input').val($first_visible_design.data('design-id'));
        $('.js-select-predefined-banner').attr('src', first_visible_img_path);
        
        if(anlass == 'Sonstiges'){
            $('#SonstigesText').removeClass("hidden");
        }else{
            $('#SonstigesText').addClass("hidden");
        }
    });


    $('body').on('click', '.js-design-predefined, .js-design-custom', function(e) {
        var clicked_id = $(this).attr("href").substr(1);
        
        if(clicked_id == 'design-custom'){
            $('input.js-selected-custom-design-input').prop('checked', true);
            $('input.js-selected-predefined-design-input').prop('checked', false);
        }else{
            $('input.js-selected-predefined-design-input').prop('checked', true);
            $('input.js-selected-custom-design-input').prop('checked', false);
        }
        resizeSameheight();
    });

    // wenn Ajax Content fertig geladen ist, wird dieser Event ausgeführt!
    $(document).on('loadedUrlPerAjaxToContent', function() {
        if ($('.js-onload-check-active-design-tab').length) {
            checkActiveDesignTabOnLoad();
        }
    });

    function checkActiveDesignTabOnLoad(){
        if ($('.js-onload-check-active-design-tab').length) {
            var active_design = $('.js-onload-check-active-design-tab input[name="Design"]:checked').val();  // 0 = eigenes Design
    
            if(active_design == 0){
                $('.js-design-custom').trigger('click');
            }else{
                $('.js-design-predefined').trigger('click');
            }
        }
    }
    checkActiveDesignTabOnLoad();
    
    $('body').on('change', '#geschenk-suche input[name="geschenktyp"]', function(e) {
        checkRelatedElementsGeschenksuche();
    });

    $('body').on('change', '#geschenk-suche input[name="programm"]', function(e) {
        checkRelatedElementsGeschenksuche();
    });

    /* 18.11.2021: war zuletzt nicht mehr im Einsatz, auch vor GoLive App-Navigation auf Prod. Daher auskommentiert
    $('body').on('change', '#Waehrung', function(e) {
        var placeholder_price = parseFloat($('#Preis').data('placeholder'));
        var str_locale = $(this).find("option:selected").data('locale');
        var price = placeholder_price.toLocaleString(str_locale, {
            style: 'decimal',
            minimumFractionDigits: 2
        });
        $('#Preis').attr('placeholder', price);
    });
    */

    $('body').on('change', '#Preis', function(e) {
        if($(this).val() == ''){
            return;
        }
        var wishlist_lang_locale = $('.wishlist-wrapper').attr('data-wishlist-language-locale');
        var set_price = parseFloat($(this).val().replace(",", "."));
        var price = set_price.toLocaleString(wishlist_lang_locale, {
            style: 'decimal',
            minimumFractionDigits: 2,
            useGrouping: false  // Tausendertrennzeichen entferne
        });
        $(this).val(price);
    });

    function loadEventTexts(){
        $('#Wunschlistentexte').addClass('hidden');

        if($('#FK_Wunschtyp').val() != ''){
            $.ajax({
                type:'GET',
                url:'/json/wunschlistentexte?wunschtyp='+$('#FK_Wunschtyp').val(),
                dataType: 'json'
            }).done(function (json) {
                if(Object.keys(json).length){
                    $('#Wunschlistentexte').removeClass('hidden');
                }else{
                    $('#Wunschlistentexte').addClass('hidden');
                }

                $("#Wunschlistentexte").find('option').not(':first').remove();
                $.each(json, function(i, val) {
                    var option = $('<option></option>').attr("value", val).text(i);
                    $("#Wunschlistentexte").append(option);
                });
            });
        }
    }

    function checkRelatedElementsGeschenksuche(){
        var $geschenk_suche = $('#geschenk-suche');
        var checked_shop = '';
        var checked_geschenk_typ = $geschenk_suche.find('input[name="geschenktyp"]').filter(':checked').val();

        if(checked_geschenk_typ != 'erlebnisse'){
            $geschenk_suche.find('#programm1').closest('.programm-wrapper').show();  // Amazon einblenden
            $geschenk_suche.find('.bundesland-box').hide();
        }else{  // Erlebnisse
            $geschenk_suche.find('#programm1').closest('.programm-wrapper').hide();  // Amazon ausblenden
        }

        if(!$geschenk_suche.find('input[name="programm"]:visible:checked').length){
            $geschenk_suche.find('input[name="programm"]:visible:first').prop('checked', true);
        }
        checked_shop = $geschenk_suche.find('input[name="programm"]').filter(':checked').val();

        $geschenk_suche.find('.affiliate-partner-box').hide();
        $geschenk_suche.find('.bundesland-box').hide();

        if(checked_shop == '2'){  // Deutschland
            $geschenk_suche.find('#affilipartnerDE').show();
            if(checked_geschenk_typ == 'erlebnisse'){
                $geschenk_suche.find('#affilipartnerDE .affiliate-partner').hide();
                $geschenk_suche.find('#affilipartnerDE .affiliate-partner.js-erlebsnisanbieter').show();
                $geschenk_suche.find('#bundeslaenderDE').show();
            }else{
                $geschenk_suche.find('#affilipartnerDE .affiliate-partner').show();
                $geschenk_suche.find('#affilipartnerDE .affiliate-partner.js-erlebsnisanbieter').hide();
            }
        }else if(checked_shop == '3'){  // Österreich
            $geschenk_suche.find('#affilipartnerAT').show();
            if(checked_geschenk_typ == 'erlebnisse'){
                $geschenk_suche.find('#affilipartnerAT .affiliate-partner').hide();
                $geschenk_suche.find('#affilipartnerAT .affiliate-partner.js-erlebsnisanbieter').show();
                $geschenk_suche.find('#bundeslaenderAT').show();
            }else{
                $geschenk_suche.find('#affilipartnerAT .affiliate-partner').show();
                $geschenk_suche.find('#affilipartnerAT .affiliate-partner.js-erlebsnisanbieter').hide();
            }
        }
    }

    $('body').on('click', '.js-geschenk-suche', function(e) {
        setTimeout(function() {  // etwas warten, bis der Content reingeladen wurde, um dann die Checks durchzuführen
            checkRelatedElementsGeschenksuche();
        }, 250);
                    
    });

    $('body').on('click', '.js-check-all-checkboxes, .js-uncheck-all-checkboxes', function(e) {
        var element_name = $(this).data('checkbox-name');
        if($(this).hasClass('js-check-all-checkboxes')){
            $('input:checkbox[name="'+element_name+'"]').prop('checked', true);
        }else{
            $('input:checkbox[name="'+element_name+'"]').prop('checked', false);
        }
    });

    // Leerzeichen Fix für die Email-Felder in den Formularen
    $('body').on('change', '#Email', function(e) {
        var inp_val = $(this).val().trim();
        $(this).val(inp_val);

        //email domain check
        var tlds = ['con','vom','fe','d','com1','comm','dw','dr','dd','clm','c','cim','coom','conm','comx','ccom','coml','comp','comn','dep'];
        var parts = inp_val.split('.');
        var lastElement = parts.pop();
        var pos = tlds.indexOf(lastElement);
        if(pos >= 0){
            $('.js-email-spelling-check').html('.'+lastElement+' ?');
        }else{
            var domains = ['gmai.com','gamil.com','gnail.com','gmail.co','wen.de','gmil.com','gmial.com','we.de','gamail.com','iclod.com','glail.com','hoymail.com','hotnail.com','jotmail.com','hotmsil.com','gmx.bet','gemail.com','gmali.com','hmail.com','gmsil.com','icould.com','gmal.com','hormail.com','wen.de'];
            var parts = inp_val.split('@');
            var lastElement = parts.pop();
            var pos = domains.indexOf(lastElement);
            if(pos >= 0){
                $('.js-email-spelling-check').html('.'+lastElement+' ?');
            }else{
                $('.js-email-spelling-check').html('');
            }
        }
    });

    $('body').on('click', 'a.external-link', function (e) {
        $.ajax({
            type: "POST",
            url: "/allgemein/saveUserAgent",
            data: { url : this.href }
        });
    });

    $('body').on('click', '.js-trigger-add-wish-btn', function(e) {
        var scrollele = $('.js-add-wish-btn');
        scrollToPosition(scrollele);
        setTimeout(function() {
            $('.js-add-wish-btn').trigger('click');
        }, 600);
    });

    $('body').on('change', '#Land', function(e) {
        var selected_country_code = $('select#Land option:selected').val();
        changeCountryCurrencyLanguage(selected_country_code);
    });
    
    if($('#check_geoip').length){
        $.ajax({
            type:'GET',
            url:'/json/getGeoLocation?ip='+$('#check_geoip').data('ip'),
            dataType: 'json',
            timeout: 5000
        }).done(function (json) {
            if(json != null){
                changeCountryCurrencyLanguage(json.country.iso_code);
            }
        });
    }

    function changeCountryCurrencyLanguage(country_code){
        switch(country_code)
        {
            case 'DE': 
            case 'AT': 
                $('#Land').val(country_code);
                $('#Waehrung').val('EUR');
                $('#Sprache').val('de');
                break;
            case 'CH':
                $('#Land').val(country_code);
                $('#Waehrung').val('CHF');
                $('#Sprache').val('de');
                break;
            case 'FR':
            case 'BE':
                $('#Land').val(country_code);
                $('#Waehrung').val('EUR');
                $('#Sprache').val('fr');
                break;
            case 'ES':
                $('#Land').val(country_code);
                $('#Waehrung').val('EUR');
                $('#Sprache').val('es');
                break;
            case 'IT':
                $('#Land').val(country_code);
                $('#Waehrung').val('EUR');
                $('#Sprache').val('it');
                break;
            case 'NL':
                $('#Land').val(country_code);
                $('#Waehrung').val('EUR');
                $('#Sprache').val('nl');
                break;
            case 'UK': 
            case 'GB': 
                $('#Land').val('UK');
                $('#Waehrung').val('GBP');
                $('#Sprache').val('en');
                break;
            case 'US': 
                $('#Land').val(country_code);
                $('#Waehrung').val('USD');
                $('#Sprache').val('en');
                break;
            case 'CA': 
                $('#Land').val(country_code);
                $('#Waehrung').val('CAD');
                $('#Sprache').val('en');
                break;
            case 'MX': 
                $('#Land').val(country_code);
                $('#Waehrung').val('MXN');
                $('#Sprache').val('es');
                break;
            case 'CL': 
                $('#Land').val(country_code);
                $('#Waehrung').val('CLP');
                $('#Sprache').val('es');
                break;
            case 'PE': 
                $('#Land').val(country_code);
                $('#Waehrung').val('PEN');
                $('#Sprache').val('es');
                break;
            case 'CO': 
                $('#Land').val(country_code);
                $('#Waehrung').val('COP');
                $('#Sprache').val('es');
                break;
            case 'AR': 
                $('#Land').val(country_code);
                $('#Waehrung').val('ARS');
                $('#Sprache').val('es');
                break;
            case 'EC': 
                $('#Land').val(country_code);
                $('#Waehrung').val('USD');
                $('#Sprache').val('es');
                break;
            case 'AU': 
                //$('#Land').val(country_code);
                $('#Waehrung').val('AUD');
                $('#Sprache').val('en');
                break;
            case 'IE': 
                $('#Land').val(country_code);
                $('#Waehrung').val('EUR');
                $('#Sprache').val('en');
                break;
        }
    }


    $('body').on('keypress', '.js-form-filter-gift-ideas .js-alter', function(e) {
        if (e.which === 13) {
            clearTimeout(timeout);
            geschenkideen_suche();
            $(this).blur();
            return false;
        }
    });

    $('body').on('click', '.js-button-filter-gift-ideas', function(e) {
        clearTimeout(timeout);
        geschenkideen_suche();
    });
    
    $('body').on('change', '.js-geschlecht_m,.js-geschlecht_w,#preis_von,#preis_bis,.js-alter', function(e) {
        // synce die 3 Felder auf der Wunschzettel Seite. Diese kommen je 2x vor!
        if($(this).hasClass('js-alter') && $('.gift-ideas-filter-gifts .js-alter').length > 1){
            $('.gift-ideas-filter-gifts .js-alter').val($(this).val());
        }
        if($(this).hasClass('js-geschlecht_m') && $('.gift-ideas-filter-gifts .js-geschlecht_m').length > 1){
            $('.gift-ideas-filter-gifts .js-geschlecht_m').prop('checked', $(this).is(':checked'));
        }
        if($(this).hasClass('js-geschlecht_w') && $('.gift-ideas-filter-gifts .js-geschlecht_w').length > 1){
            $('.gift-ideas-filter-gifts .js-geschlecht_w').prop('checked', $(this).is(':checked'));
        }

        clearTimeout(timeout);
        timeout = setTimeout(function () {
            geschenkideen_suche();
        }, 750);
    });

    if ($('#user-wishes-wrapper').data('bookmarked-wish-id') !== undefined) {
        var bookmarked_wish_id = $('#user-wishes-wrapper').data('bookmarked-wish-id');
        showNotify(lang_wishlist_wish_added_successfully, 'success');
        handleAfterBookmark();
        scrollToPosition('.js-add-wish-btn');
    }

    // Wenn Auto-Bookmark nicht geht, wird hier die Url in das Wunsch eintragen Fenster eingefügt
    if ($('#user-wishes-wrapper').attr('data-bookmark-url-manually') !== undefined) {
        var bookmarked_wish_url = decodeURIComponent($('#user-wishes-wrapper').data('bookmark-url-manually'));
        //var wishlist_url_hash = $('.wishlist-wrapper').data('wishlist-hash');
        setTimeout(function () {  // timeout notwendig, sonst würde der Hash sofort beim Laden entfernt werden und Modal zugehen!
            $('.js-add-wish-btn').trigger('click');
        }, 200);

        $('body').on('loaded.bs.modal', '#addwish', function (event) {
            if ($('#user-wishes-wrapper').attr('data-bookmark-url-manually') !== undefined) {
                $(event.target).find('#js-geschenk-eintragen').trigger('click');
                $(event.target).find('input#URL').val(bookmarked_wish_url).trigger('change');
                //history.replaceState(stateObj, lang_wishbob_wishlist_text, '/' + wishlist_url_hash);  // Text = Wishbob Wunschzettel  // 11.09.2022 - hier nicht mehr notwendig denke ich.
            }
        });

        // nach dem Schließen des Modals wird die Klasse entfernen. Beim Öffnen wird darauf geprüft!
        $('body').on('hidden.bs.modal', '#addwish', function (event) {
            $('#user-wishes-wrapper').removeAttr('data-bookmark-url-manually');
        });
    }

    /* Detect mobile device and show App Download bar if there is one */
    function checkApphint() {
        var elem_app_hint = $('.js-app-hint');
        
        function changeTopMargin() {
            $('body, .header.startpage, .sidebar').css('margin-top', elem_app_hint.outerHeight());  // 17.11.2024 - fix, nur auf header wenn startpage
        }

        if (elem_app_hint.length) {
            if (userAgent !== undefined && userAgent !== 'ios' && elem_app_hint.find('a[data-device="' + userAgent + '"]').length && checkCookie('wishlistAppLoad', elem_app_hint.attr('data-app')) === null) {
                elem_app_hint.show();
                elem_app_hint.find('a[data-device="' + userAgent + '"]').removeClass('display-none');
                $('body, .header.startpage, .sidebar').css('margin-top', elem_app_hint.outerHeight());  // 17.11.2024 - fix, nur auf header wenn startpage
                $(window).on('resize', changeTopMargin);

                $('a.js-app-load, a.js-app-close').click(function (e) {
                    var element = $(this),
                        ctime = 1;

                    if (element.hasClass('js-app-load')) {
                        ctime = 30;
                    }
                    setCookie('wishlistAppLoad', elem_app_hint.attr('data-app'), ctime);
                    element.closest('.js-app-hint').slideUp();
                    $('body, .header, .sidebar').css('margin-top', 0);
                    $(window).off('resize', changeTopMargin);
                    if (element.hasClass('js-app-close')) {
                        e.preventDefault();
                    }
                });
            }
        }
    }
    checkApphint();

    // banner cookie management
    function checkBannerCookie() {
        var $banner_cookie = $('.js-banner-cookie');

        $banner_cookie.each(function(index) {
            var banner_id = $(this).attr('data-banner-id');
            var cookie_days =  $(this).attr('data-cookie-days') !== undefined ? $(this).attr('data-cookie-days') : 400;  // Chrome und vermutlich andere auch erlauben nur mehr max. 400 Tage!
            var $elem = $(this);
            var tmp_timeout = 0;

            if (checkCookie(banner_id, 'true') === null) {
                $(this).removeClass('display-none').addClass('display-inline-block');
                $(this).find('a.close-alert, a.close').on('click', function (e) {
                    if($(this).hasClass('close-alert')){
                        if($(this).hasClass('external-link')){
                            tmp_timeout = 100;  // fix, wenn der Link getracked werden soll, braucht es bissi timeout.
                        }
                        setTimeout(function () {
                            $elem.closest('.alert').alert('close');
                        }, tmp_timeout);
                    }
                    setCookie(banner_id, 'true', cookie_days);
                });
            }
        });
    }
    checkBannerCookie();

    var urlparserIsRunning = false;
    $('body').on('paste change', '#geschenk-eintragen #URL, #form-edit-add-gift-idea #URL', function(e) {
        var event_type = e.type;
        var $elem = $(this);
        var keywords = $elem.val();
        var pasted_text;
        var cleaned_keywords;

        if(event_type == 'paste'){
            // auf $elem.val(); hat man nicht immer sofort Zugriff, da paste schon vorher passiert! Hier daher aus dem Clipboard holen!
            if (window.clipboardData && window.clipboardData.getData) { // IE
                pasted_text = window.clipboardData.getData('Text');
            }
            else if (e.originalEvent.clipboardData && e.originalEvent.clipboardData.getData) { // other browsers
                pasted_text = e.originalEvent.clipboardData.getData('text/plain');
            }
            
            setTimeout(function () {
                cleaned_keywords = pasted_text.substring(pasted_text.indexOf('http'));

                if(keywords !== cleaned_keywords){
                    $elem.val(function(){
                        return cleaned_keywords; 
                    }).trigger('change');
                }
                $elem.trigger('blur');
            }, 0);
        }
        
        // Geschenkideen Verwalten Seite
        if($('#form-edit-add-gift-idea').length){
            $('#Bezeichnung').val('');
            $('#Bild').val('');
            $('#Preis').val('');
            $('#UniqueID').val('');
            $('#FK_Partnerprogramm').prop("selectedIndex", 0);
        }else{  // Wunsch eintragen/bearbeiten
            // Formular Felder zurücksetzen
            $('.js-image-preview').attr('src', '');
            $('input[type="hidden"]#BildURL').val('');
            $('#Name').val('');
            $('#Preis').val('');
            //$('#Waehrung option[value="EUR"]').prop('selected', true);  // Standardwert EUR  // 15.01.2023 - muss nicht zurückgesetzt werden!
        }

        clearTimeout(timeout);
        timeout = setTimeout(function () {
            if(keywords.trim() != '' && keywords.trim().length >= 2){
                if($elem.valid() && !urlparserIsRunning){  // nur wenn Feld valide Url
                    $('#URL').closest('div').append('<div class="text-center loading-spinner margin-bottom-medium margin-top-medium"><i class="fa fa-spinner fa-spin fa-2x color-primary"></i><br>' + lang_add_url_loading_msg + '</div>');
                    parseURL();
                }
            }
        }, 400);
    });

    function parseURL(){
        urlparserIsRunning = true;
        $.ajax({
            type:'POST',
            url:'/wunsch/parseURL',
            data : {'url' : $('#URL').val()},
            dataType: 'json',
            timeout: 6000 // sets timeout to 6 seconds
        }).done(function (json) {
            $('.js-image-preview').attr('src', json.image_url);
                // Geschenkideen Verwalten Seite
                if($('#form-edit-add-gift-idea').length){
                    $('#Bild').val(json.image_url);
                    $('#Bezeichnung').val(json.title);
                    var land = json.domain.split('.');
                    $('#Land option[value="'+land[land.length-1].toUpperCase()+'"]').prop('selected', true); 
                    var waehrung = 'EUR';
                    if(land[land.length-1] == 'uk')
                        waehrung = 'GBP';
                    $('#Waehrung option[value="'+waehrung+'"]').prop('selected', true); 
                }else{  // Wunsch eintragen/bearbeiten
                    $('input[type="hidden"]#BildURL').val(json.image_url);
                    $('#Name').val(json.title);
                    $('#URL_Affilinet').val(json.url_affilinet);
                    $('#Waehrung option[value="'+json.currency+'"]').prop('selected', true);
                }
                $('#Preis').val(json.price_float).trigger('change');
                $('.loading-spinner').remove();
        }).fail(function (jqXHR, textStatus, errorThrown) {
            urlparserIsRunning = false;
            if(textStatus==="timeout") {
                $('.loading-spinner').remove();
            }
        }).always(function() {
            urlparserIsRunning = false;
        });
    }
    
    function geschenkideen_suche(){
        $('.js-gift-ideas-search').each(function(index, elem) {
            var btn = $(elem).find('.js-button-filter-gift-ideas');
            var alter = $(elem).find('.js-alter').val();
            var preis_von = $(elem).find('#preis_von').val();
            var preis_bis = $(elem).find('#preis_bis').val();
            var anlass = $(elem).find('#anlass').val();
            var referrer_idee = $(elem).find('#referrer_idee').val();
            var nur_top_geschenke = $(elem).find('#nur_top_geschenke').val() == 1 ? 1 : 0;
            var geschlecht = '';
            if($(elem).find('.js-geschlecht_m').is(':checked')) geschlecht += $(elem).find('.js-geschlecht_m').val();
            if($(elem).find('.js-geschlecht_w').is(':checked')) geschlecht += $(elem).find('.js-geschlecht_w').val();
            btn.button('loading');

            $(elem).find('.js-gift-ideas-results .js-gift-ideas-wrapper').html('<div class="text-center loading-spinner"><i class="fa fa-spinner fa-spin fa-2x color-primary"></i></div>');
            $(elem).find('.js-gift-ideas-results .js-gift-ideas-results-title').addClass('hidden');

            var obj_json_data = {
                'geschlecht': geschlecht,
                'ajax': 1,
                'alter': alter,
                'preis_von': preis_von,
                'preis_bis': preis_bis,
                'anlass': anlass,
                'referrer_idee': referrer_idee,
                'nur_top_geschenke': nur_top_geschenke
            };
        
            $.ajax({
                type:'POST',
                url:'/wunschzettel/geschenkideen',
                data : obj_json_data
            }).done(function (data) {
                var $loaded_content = $(data).find('.js-gift-ideas-results');
                if($('#wunschlisteverwalten').length){  // Verwalten Seite
                    $(elem).find('.js-gift-ideas-results-title').html($loaded_content.find('.js-gift-ideas-results-title').html());
                    if($(elem).closest('#gift-ideas-in-wishlist').length){  // Geschenkideen in Wunschzettel!
                        $('#wunschlisteverwalten .js-gift-ideas-in-wishlist-counter').text($loaded_content.find('.js-found-gift-ideas-counter').text());
                    }
                    $(elem).find('.js-gift-ideas-results .js-gift-ideas-results-title').removeClass('hidden');
                    /*
                    $(elem).find('.js-gift-ideas-results .js-gift-ideas-wrapper').html('');  // vorher leeren
                    $(elem).find('.js-gift-ideas-results .js-gift-ideas-wrapper').html($loaded_content.find('.js-gift-ideas-wrapper').html());
                    */
                   $(elem).find('.js-gift-ideas-results').replaceWith($loaded_content);
                   $(elem).find('.js-gift-ideas-results').removeClass('bg-grey-k8 padding-bottom-large pos-rel');  // weile diese von der Geschenkideen Seite kommen und auf der Verwalten Seite nicht benötigt werden!
                   $(elem).find('.js-gift-ideas-results').find('div.bg-full').remove();
                   $(elem).find('.js-gift-ideas-results').find('.js-wishes-view-mode-xs').closest('div').remove();
                }else{
                    $(elem).find('.js-gift-ideas-results').replaceWith($loaded_content);
                }
                btn.button('reset');
                resizeSameheight();  // damit werden die Boxen neu berechnet!
                inviewLazyLoad();  // damit die LazyLoad Images hier bei nachgeladenem Content auch funktionieren.
            });
        });
        
    }

    function markItemBought(wish_id, setcache, callback){
        var bought_wishes = Cookies.get('marked_bought_wishes');
        var cookie_expire_in_days = 365;
        var obj_bought_wishes = tryParseJSON(bought_wishes);
        var arr_wish_ids = [];
        var clicked_wish_id = wish_id;
        var str_add_classes = 'wish-fulfilled focused';
    
        if(setcache){  // Wenn cache geschrieben wird, dann ist es der aktuelle User, daher auch die Klasse .wish-fulfilled-by-current-user setzen!!
            str_add_classes = 'wish-fulfilled wish-fulfilled-by-current-user focused';

            if ($('.wishlist-wrapper').data('wishlist-days-to-end') !== undefined) {
                cookie_expire_in_days = $('.wishlist-wrapper').data('wishlist-days-to-end');
                cookie_expire_in_days = cookie_expire_in_days + 30;  // Enddatum + 30 Tage gültig
            }
        
            if(obj_bought_wishes){  // wenn das Cookie Objekt vorhanden ist
                if (!isInArray(clicked_wish_id, obj_bought_wishes.ids)){  // nur wenn noch nicht in Array vorhanden, hinzufügen
                    obj_bought_wishes.ids.push(clicked_wish_id);
                }
                arr_wish_ids = obj_bought_wishes.ids;
            }else{
                arr_wish_ids.push(clicked_wish_id);
            }
        
            // Mache array unique
            arr_wish_ids = arr_wish_ids.filter(function(item, pos){
                return arr_wish_ids.indexOf(item)== pos; 
            });
        
            Cookies.set('marked_bought_wishes', {'ids' : arr_wish_ids}, { expires: cookie_expire_in_days });
        }

        $("#wunsch_" + wish_id + " .wish").addClass(str_add_classes).delay(1500).queue(function(){
            $(this).removeClass("focused").dequeue();
            callback();
        });
    }
    
    function unmarkItemBought(wish_id, deletecache, callback){
        var bought_wishes = Cookies.get('marked_bought_wishes');
        var cookie_expire_in_days = 365;
        var obj_bought_wishes = tryParseJSON(bought_wishes);
        var arr_wish_ids = [];
        var clicked_wish_id = wish_id;
    
        if(deletecache){
            if ($('.wishlist-wrapper').data('wishlist-days-to-end') !== undefined) {
                cookie_expire_in_days = $('.wishlist-wrapper').data('wishlist-days-to-end');
                cookie_expire_in_days = cookie_expire_in_days + 30;  // Enddatum + 30 Tage gültig
            }
        
            if(obj_bought_wishes){  // wenn das Cookie Objekt vorhanden ist
                if (isInArray(clicked_wish_id, obj_bought_wishes.ids)){
                    arr_wish_ids = obj_bought_wishes.ids.filter(function(val) {
                        return val !== clicked_wish_id;
                    });
                }
            }
        
            // Mache array unique
            arr_wish_ids = arr_wish_ids.filter(function(item, pos){
                return arr_wish_ids.indexOf(item)== pos; 
            });
            if(!arr_wish_ids.length){  // wenn Array leer, Cookie komplett löschen!
                Cookies.remove('marked_bought_wishes');
            }else{
                Cookies.set('marked_bought_wishes', {'ids' : arr_wish_ids}, { expires: cookie_expire_in_days });
            }
        }

        $("#wunsch_" + wish_id + " .wish").removeClass('wish-fulfilled wish-fulfilled-by-current-user').addClass('focused').delay(1500).queue(function(){
            $(this).removeClass("focused").dequeue();
            callback();
        });
    }

    /* AJAX BOOKMARK STARTS */
    if($('.js-do-ajax-bookmark').length){
        var $elem = $('.js-do-ajax-bookmark');
        var bookmark_url = $elem.data('bookmark-url');
        var public_hash = $elem.data('public-hash');
        var stateObj = { title: lang_wishbob_wishlist_text };

        if(bookmark_url !== undefined && public_hash !== undefined){
            $.ajax({
                type:'GET',
                url: bookmark_url+'&ajax=1'
            }).done(function (data) {
                history.replaceState(stateObj, lang_wishbob_wishlist_text, '/' + public_hash);
                location.href = public_hash;
                //handleAfterBookmark();
            }).fail(function () {
                //showNotify(lang_ajax_save_error_text, 'error');
                history.replaceState(stateObj, lang_wishbob_wishlist_text, '/' + public_hash);
                location.href= bookmark_url+'&error=1';
            });
        }
    }

    // 11.09.2022 - neue Funktion, um nach dem Bookmark aus Android Teilen-Funktion wieder die Wishbob-App zuzumachen oder dem ShopBrowser den ShopBrowser wieder zu öffnen
    function handleAfterBookmark(){
        var url_ref = '';

        if ($('#user-wishes-wrapper').data('bookmarked-wish-ref') !== undefined) {
            url_ref = $('#user-wishes-wrapper').data('bookmarked-wish-ref');
        }

        if(url_ref == 'android_shopbrowser' || url_ref == 'ios_shopbrowser'){
            setTimeout(function(){
                if (url_ref == 'ios_shopbrowser'){
                    $('.js-open-ios-shopbrowser-back')[0].click();
                }else{
                    if(typeof Android !== 'undefined'){
                        Android.openShopBrowserBack();
                    }
                }
            }, 1500);
        }else{
            setTimeout(function(){
                if(typeof Android !== 'undefined'){
                    Android.closeBookmark();
                }
            }, 1500);
        }
    }
    /* AJAX BOOKMARK ENDS */

    /* SHOW MARKED/ALL WISHES STARTS */
    $('body').on('click', '.js-show-which-wishes', function(e) {
        var show_which = $(this).data('show-wishes');
        $('.js-show-which-wishes').removeClass('active');
        $(this).addClass('active');
        
        $('#user-wishes-wrapper .wish-fulfilled').parent().each(function(index) {
            if(show_which == 'unbought'){  // unbought | all
                $(this).hide();
            }else{
                $(this).show();
            }
        });
    });
    /* SHOW MARKED/ALL WISHES ENDS */

    /* MOBILE LIST VIEW */
    $('body').on('click', '.js-wishes-view-mode-xs', function(e) {
        var wishes_view_mode_xs = $(this).attr('data-wishes-view-mode-xs');
        var view_mode_xs_set;

        if(wishes_view_mode_xs == 'list'){
            view_mode_xs_set = 'tile';
            $(this).attr('data-wishes-view-mode-xs', 'tile');
            $(this).find('i').removeClass('fa-list').addClass('fa-th-large');
            $('#user-wishes-wrapper, .js-gift-ideas-wrapper').addClass('wishes-view-mode-xs-tile');
        }else{  // 'tile'
            view_mode_xs_set = 'list';
            $(this).attr('data-wishes-view-mode-xs', 'list');
            $(this).find('i').removeClass('fa-th-large').addClass('fa-list');
            $('#user-wishes-wrapper, .js-gift-ideas-wrapper').removeClass('wishes-view-mode-xs-tile');
        }
        setCookie('wishes_view_mode_xs', '', -1);  // zuerst löschen
        setCookie('wishes_view_mode_xs', view_mode_xs_set, 3650);  // 10 Jahre
    });
    /* MOBILE LIST VIEW */

    /* SHOW APP VERSION UPDATE STARTS */
    (function() {
        setTimeout(function() {
            if(!Swal.isVisible() && !$('.modal').hasClass('in')){
                // Texte und HTML aus dem Template holen
                var $swal_html = $("script[data-template='js-template-app-update-new-version']").html();
                $swal_html = $('<div />').html($swal_html);
                var swal_title = $swal_html.find('.template-swal-title').text();
                var swal_confirm_button_text = $swal_html.find('.template-swal-confirm-text').text();
                var swal_cancel_button_text = $swal_html.find('.template-swal-cancel-text').text();
                $swal_html.find('.template-swal-title, .template-swal-confirm-text, .template-swal-cancel-text').remove();

                if(typeof(android_app_version) != "undefined" && android_app_version !== null && android_app_version < android_latest_app_version) {
                    if (checkCookie('androidAppStoreUpdate', 'true') === null) {
                        
                        CustomHashSwal.fire({
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            title: swal_title,
                            html: $swal_html,
                            //icon: "warning",
                            showCloseButton: true,
                            showCancelButton: true,
                            focusConfirm: true,
                            confirmButtonText: swal_confirm_button_text,
                            cancelButtonText: swal_cancel_button_text
                        })
                        .then(function (result) {
                            if (result.value) {
                                window.open(play_store_url);
                                setCookie('androidAppStoreUpdate', 'true', 1);
                            }else if (result.dismiss === Swal.DismissReason.cancel) {
                                setCookie('androidAppStoreUpdate', 'true', 1);
                            }else if (result.dismiss === Swal.DismissReason.close  || result.dismiss === Swal.DismissReason.esc) {
                                setCookie('androidAppStoreUpdate', 'true', 7);
                            }
                        });
                    
                    }
                }
            }
        }, 400);
    })();
    /* SHOW APP VERSION UPDATE ENDS */

    /* SHOW FEEDBACK QUESTION FOR ANDROID APP STARTS */
    (function() {
        setTimeout(function() {
            if(!Swal.isVisible() && !$('.modal').hasClass('in') && $('.js-android-app-leave-feedback, .js-ios-app-leave-feedback').length){
                var cookie_name_store_feedback = '';
                var to_open_store_url = '';
                // Texte und HTML aus dem Template holen
                var $swal_html = $("script[data-template='js-template-rate-wishbob']").html();
                $swal_html = $('<div />').html($swal_html);
                var swal_title = $swal_html.find('.template-swal-title').text();
                var swal_confirm_button_text = $swal_html.find('.template-swal-confirm-text').text();
                var swal_cancel_button_text = $swal_html.find('.template-swal-cancel-text').text();
                var swal_thx_title = $swal_html.find('.template-swal-thx-title').text();
                var swal_thx_text = $swal_html.find('.template-swal-thx-text').text();
                $swal_html.find('.template-swal-title, .template-swal-confirm-text, .template-swal-cancel-text, .template-swal-thx-title, .template-swal-thx-text').remove();

                if($('.js-android-app-leave-feedback').length){
                    cookie_name_store_feedback = 'androidAppStoreFeedback';
                    to_open_store_url = play_store_url;
                }else if($('.js-ios-app-leave-feedback').length){
                    cookie_name_store_feedback = 'iosAppStoreFeedback';
                    to_open_store_url = ios_store_url;
                }

                if (checkCookie(cookie_name_store_feedback, 'true') === null) {
                    // in App Review für Android User ab Version 11, sonst wie gehabt das Overlay mit Link zum Store!
                    if(typeof(android_app_version) != "undefined" && android_app_version !== null && android_app_version >= 11 && cookie_name_store_feedback == 'androidAppStoreFeedback'){
                        setTimeout(function() {
                            Android.inAppReview();
                            setCookie(cookie_name_store_feedback, 'true', 32);  // hierzu gibt es von Google keine konkrete Zeit https://developer.android.com/guide/playcore/in-app-review#quotas
                        }, 1000);
                    }else{
                        CustomHashSwal.fire({
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            title: swal_title,
                            html: $swal_html,
                            icon: "info",
                            iconHtml: "👋",
                            showCloseButton: true,
                            showCancelButton: true,
                            focusConfirm: true,
                            confirmButtonText: swal_confirm_button_text,
                            cancelButtonText: swal_cancel_button_text
                        })
                        .then(function (result) {
                            if (result.value) {
                                //window.open(to_open_store_url);  // geht nicht in iOS App, da geblockt wird!!
                                $('.js-open-store')[0].click();
                                setCookie(cookie_name_store_feedback, 'true', 180);
                                setTimeout(function() {
                                    CustomHashSwal.fire({
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        title: swal_thx_title,
                                        text: swal_thx_text,
                                        icon: 'success'
                                    });
                                }, 1000);
                            }else if (result.dismiss === Swal.DismissReason.cancel) {
                                setCookie(cookie_name_store_feedback, 'true', 1);
                            }else if (result.dismiss === Swal.DismissReason.close  || result.dismiss === Swal.DismissReason.esc) {
                                setCookie(cookie_name_store_feedback, 'true', 14);
                            }
                        });
                    }
                }
            }
        }, 400);
    })();
    /* SHOW FEEDBACK QUESTION FOR ANDROID APP ENDS */


    /* SHOW SURVEY STARTS */
    (function() {
        setTimeout(function() {
            if($('.js-show-survey').length && !Swal.isVisible() && !$('.modal').hasClass('in') && CookieConsent.validConsent()){  // nur wenn kein Modal, Swal oder Cookie Consent offen ist
                // Texte und HTML aus dem Template holen
                var $swal_html = $("script[data-template='js-template-survey']").html();
                $swal_html = $('<div />').html($swal_html);
                var swal_title = $swal_html.find('.template-swal-title').text();
                var cookie_name_to_check = $swal_html.find('.template-swal-cookie-name').text();
                var swal_confirm_button_text = $swal_html.find('.template-swal-confirm-text').text();
                var swal_cancel_button_text = $swal_html.find('.template-swal-cancel-text').text();
                var swal_thx_title = $swal_html.find('.template-swal-thx-title').text();
                var swal_thx_text = $swal_html.find('.template-swal-thx-text').text();
                $swal_html.find('.template-swal-title, .template-swal-cookie-name, .template-swal-confirm-text, .template-swal-cancel-text, .template-swal-thx-title, .template-swal-thx-text').remove();

                if (checkCookie(cookie_name_to_check, 'true') === null) {
                    CustomHashSwal.fire({
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        title: swal_title,
                        html: $swal_html,
                        icon: "info",
                        iconHtml: '<img src="/assets/img/icons/app-download-128x128.png" style="max-width:100px">',
                        showCloseButton: true,
                        showCancelButton: true,
                        focusConfirm: true,
                        confirmButtonText: swal_confirm_button_text,
                        cancelButtonText: swal_cancel_button_text
                    })
                    .then(function (result) {
                        if (result.value) {
                            $('.js-open-link')[0].click();
                            setCookie(cookie_name_to_check, 'true', 180);
                            setTimeout(function() {
                                CustomHashSwal.fire({
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    title: swal_thx_title,
                                    text: swal_thx_text,
                                    icon: 'success'
                                });
                            }, 1000);
                        }else if (result.dismiss === Swal.DismissReason.cancel) {
                            setCookie(cookie_name_to_check, 'true', 1);
                        }else if (result.dismiss === Swal.DismissReason.close  || result.dismiss === Swal.DismissReason.esc) {
                            setCookie(cookie_name_to_check, 'true', 14);
                        }
                    });
                }
            }
    }, 1500);
    })();
    /* SHOW SURVEY ENDS */

    /* CHECK IF WISHLIST WISHES WERE CHANGED STARTS */
    var wishStatChangedTimeout;
    // Die Funktion überprüft alles 60 Sekunden per Ajax Call, ob sich im Wunschzettel Änderungen getan haben.
    function checkWishStatsChanged(){
        if($('.js-wishlist-guestmode').length){
            var wishes_count_total;
            var wishes_count_reserved;
            var wishlist_url_hash = $('.wishlist-wrapper').data('wishlist-hash');
            // Texte und HTML aus dem Template holen
            var $swal_html = $("script[data-template='js-template-wishlist-changed-reload-it']").html();
            $swal_html = $('<div />').html($swal_html);
            var swal_title = $swal_html.find('.template-swal-title').text();
            $swal_html.find('.template-swal-title').remove();

            wishStatChangedTimeout = setTimeout(function() {
                $.ajax({
                    url: "/json/getwishstats/wunschzettel/" + wishlist_url_hash+'/language/'+page_lang,
                    method: "get"
                })
                .done(function (response) {
                    wishes_count_total = $('.js-wishlist-stat-wishes-total').text();
                    wishes_count_reserved = $('.js-wishlist-stat-wishes-reserved').text();

                    if(wishes_count_total != response.count_wishes_total || wishes_count_reserved != response.count_bought_wishes){  // es haben Änderungen stattgefunden
                        if(!Swal.isVisible() && !$('.modal').hasClass('in')){  // Swal nur ausführen wenn kein Swal oder Modal offen ist!
                            setTimeout(function() {  // a little timeout needed for iOS
                                CustomHashSwal.fire({
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    title: swal_title,
                                    html: $swal_html,
                                    //text: "Dann würden wir uns über eine Bewertung auf Google Play freuen!<br>Mit deinem Feedback können wir Wishbob stetig verbessern.",
                                    icon: "info",
                                    iconHtml: '<i class="fa fa-fw fa-refresh" aria-hidden="true"></i>',
                                    focusConfirm: true
                                })
                                .then(function (result) {
                                    if (result.value) {
                                        reloadWishesSimple(function(){
                                            // wenn load function fertig, dann Funktion erneut aufrufen.
                                            checkWishStatsChanged();
                                            showNotify(lang_wishlist_reloaded_text, 'success');
                                        });
                                    }
                                });
                            }, 400);
                        }else{
                            checkWishStatsChanged();
                        }
                    }else{
                        checkWishStatsChanged();
                    }
                });
            }, 15000);  // 60 sek
        }else{
            clearTimeout(wishStatChangedTimeout);
        }
    }
    checkWishStatsChanged();
    /* CHECK IF WISHLIST WISHES WERE CHANGED ENDS */
    
    
    /* SHOW APP DOWNLOAD BEFORE CREATE WISHLIST STARTS */
    (function() {
        if($('.js-add-wishlist-in-app').length && userAgent !== undefined){  // only for Android
            var store_url = play_store_url;
            // Texte und HTML aus dem Template holen
            var $swal_html = $("script[data-template='js-template-add-wishlist-in-app']").html();
            $swal_html = $('<div />').html($swal_html);
            var swal_title = $swal_html.find('.template-swal-title').text();
            var swal_confirm_button_text = $swal_html.find('.template-swal-confirm-text').text();
            $swal_html.find('.template-swal-title, .template-swal-confirm-text').remove();

            if(userAgent == 'android'){
                store_url = play_store_url;
            }else if(userAgent == 'ios'){
                store_url = ios_store_url;
            }
            $swal_html.find('.js-template-fill-in-url').attr('url', store_url);

            // workaround 12.09.2023
            $('body').on('click', '#js-trigger-add-wishlist-in-app', function(e) {
                setTimeout(function() {
                    CustomHashSwal.fire({
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        title: swal_title,
                        html: $swal_html,
                        showCloseButton: true,
                        //showCancelButton: true,
                        focusConfirm: true,
                        confirmButtonText: swal_confirm_button_text
                        //cancelButtonText: "Nein danke"
                    })
                    .then(function (result) {
                        if (result.value) {
                            window.open(store_url);
                        }
                    });
                }, 800);
            });
        }
    })();
    /* SHOW APP DOWNLOAD BEFORE CREATE WISHLIST ENDS */


    /* SORT WISHES STARTS */
    // Quelle http://sortablejs.github.io/Sortable/#comparisons
    var sortable;

    window.sortableWishes = function(){
    //function sortableWishes(){
        if ($('#user-wishes-wrapper').length > 0 && $('#user-wishes-wrapper .wish-wrapper').length > 1 && $('#user-wishes-wrapper .wish-wrapper .sortable-wish-move').length > 0) {
            var userWishesWrapper = $('#user-wishes-wrapper div.row')[0];

            sortable = new Sortable(userWishesWrapper, {
                sort: true,
                //swap: true,
                dataIdAttr: 'data-id',
                handle: '.sortable-wish-move',
                draggable: '.wish-wrapper',
                //ghostClass: 'sortable-wish-ghost',
                chosenClass: 'sortable-wish-chosen',
                //swapClass: 'sortable-wish-swap',
                dragClass:'sortable-wish-drag',
                animation: 250,
                //filter: 'input, button',
                preventOnFilter: false,
                delay: 250,
                delayOnTouchOnly: true,
                onChoose: function(evt){
                    if(navigator.vibrate) {  // vibration API supported
                        window.navigator.vibrate(100); // vibriert 100ms lang
                    }
                },
                onStart: function(evt){
                    $('html').addClass('sortable-sorting-active');
                    // on start
                    setTimeout(function() {
                        $(evt.item).find('.sortable-wish-move.tooltipstered').tooltipster("hide");
                    }, 200);
                },
                onEnd: function(evt){
                    $('html').removeClass('sortable-sorting-active');
                    if(!isMobile.any()){  //check if mobile device
                        $('.wish-wrapper').removeClass('wish-hover');
                        $(evt.item).trigger('mouseenter');
                    }
                },
                onUpdate: function (evt) {
                    // updated
                    saveWishPositions();
                    if(navigator.vibrate) {  // vibration API supported
                        window.navigator.vibrate(400); // vibriert 400ms lang
                    }
                },
                onMove: function(evt){
                    if(!isMobile.any()){  //check if mobile device
                        $('.wish-wrapper').removeClass('wish-hover');
                        $(evt.dragged).trigger('mouseenter');
                    }

                    if(navigator.vibrate) {  // vibration API supported
                        window.navigator.vibrate(50); // vibriert 50ms lang
                    }
                }
            });

            if(!isMobile.any()){  //check if mobile device
                $('.wish-wrapper').on('mouseenter mouseover', function(){
                    $(this).addClass('wish-hover');
                }).on('mouseleave', function(){
                    $(this).removeClass('wish-hover');
                });
            }
        }
    }
    sortableWishes();

    function saveWishPositions(){
        var obj_wishes = [];
        //var wishlist_url_hash = $('.wishlist-wrapper').data('wishlist-hash');

        $('.wishes-wrapper .wish-wrapper').each(function(index){
            var wish_id = $(this).find('.wish').attr('data-wish-id');
            obj_wishes.push({
                'id': wish_id,
                'position': index+1
            });
        });

        $.ajax({
            type: "POST",
            url:'/json/positionsupdate/language/'+page_lang,
            data: {mydata: JSON.stringify(obj_wishes)},
            //contentType: "application/json; charset=utf-8",
            //dataType: "json",
        })
        .done(function(response) {
            var status = response.status;
            var message = response.message;

            if (status == 'success') {
                 // hier könnte noch ein visuelles Feedback gemacht werden, da Speicherung erfolgreich war.
            }
        })
        .fail(function() {
            showNotify(change_wish_pos_error, 'error');
        });
    }
    /* SORT WISHES ENDS */

    $('body').on('click', '.js-save-friendslist', function(e) {
        var postData = new FormData($(this).closest('form')[0]);
        var $this_btn = $(this);
        e.preventDefault();

        if (form.valid()) {
            $('.js-add-friends-wishlist-validation-errors').addClass('display-none')

            $.ajax({
                type:'POST',
                url:'/json/saveFriendsWishlist/language/'+page_lang,
                processData: false,
                contentType: false,
                data : postData,
                /*
                data: {
                    'url': 1 // anzahl
                }
                */
            }).done(function (response) {
                if (response.status == 'success') {
                    $('.js-friends-wishes-wrapper').load(' .js-friends-wishes-wrapper > *', function(){  // "> *" nimmt alle children von dem gefundenen Element
                        $(".modal").modal('hide');
                        $this_btn.button('reset');
                        $this_btn.closest('.modal-content').find('input[name=url]').val('');
                        setTimeout(function() {
                            showNotify(response.message, 'success');
                        }, 2000);
                    });  // goes on current url
                }else if (response.status == 'error') {  // status = error
                    $this_btn.button('reset');
                    $('.js-add-friends-wishlist-validation-errors').removeClass('display-none').html(response.message);
                    //showNotify(response.message, 'error');
                }
            }).fail(function () {
                showNotify(lang_ajax_save_error_text, 'error');
            });
        }else{
            //  not valid
        }
    });

    // Funktion, um die blockierten Affiliate Scripts zu identifizieren.
    setTimeout(function() {
        var affiliate_js_not_loaded = false;
        var aff_netw = '';

        if(typeof AWIN === 'undefined'){
            affiliate_js_not_loaded = true;
            aff_netw += 'awin';
        }
        
        if(typeof TDLinkConverter == 'undefined'){
            affiliate_js_not_loaded = true;
            aff_netw += (aff_netw != '' ? '+' : '') + 'tradedoubler';
        }

        if(affiliate_js_not_loaded){
            if($.active === 0){  // nur wenn kein Ajax Request aktiv ist, abfeuern! Sonst funktionieren andere Ajax done Funktionen nicht mehr richtig!
                $.ajax({
                    type: "POST",
                    url: "/allgemein/saveBlockedScripts",
                    data: { url : location.href, netw : aff_netw }
                });
            }
        }
     }, 2000);

    /* App Footer */
    $('body').on('click', '.js-app-footer .nav-item.active', function(e){
        e.preventDefault();
        return false;
    });

    if($('body').hasClass('is-app')){
        var initial_loaded_url = window.location.pathname + window.location.search;
        var initial_loaded_url_title = document.title;
        var initial_loaded_overview_url = $('.js-nav-item-home').attr('href');
        if (history && history.replaceState && history.pushState) {
            history.replaceState(null, 'Overview', initial_loaded_overview_url);
            history.pushState(null, initial_loaded_url_title, initial_loaded_url);
		}
        
        var last_hash = location.hash.replace('#', '');

        $(window).on("popstate", function(e) {
            var state = e.originalEvent.state;
            var hash_val_location = location.hash.replace('#', '');
    
            if(hash_val_location == '' && last_hash == ''){  // wenn aktuell kein Hash und letzter Wert kein Hash (z.B. nach Modal schließen)
                var location_pathname = window.location.pathname;

                loadUrlPerAjaxToContent(location_pathname);
            }
            last_hash = hash_val_location;
            /*
            if(state !== null){
                away_from_home = history.state.away_from_home;
                page_id = state.page_id + 1;
            }

            if(hash_val_location !== 'bookmark' && hash_val_location !== 'modal' && hash_val_location !== 'swal'){
                handleJsHashNavigation(hash_val_location, true);
            }else{
                //location.href = '/#watchlist';
            }
            */
        });

        // Pnotify anpassen
        pnotify_stack_options = {"dir1": "up", "dir2": "left", "firstpos1": 55, "firstpos2": 25};
        pnotify_animate_options = {animate: true, in_class: 'bounceIn', out_class: 'bounceOut' };
    }

    // temporär, um den Apple Login Button anzuzeigen, Apple iOS Version größer 15.7
    function handleiOSsocialButton() {
        if ($('.js-social-login-btn-apple').length) {
            var ver = iOSversion();
            if(ver >= 15.7){
                $('.js-social-login-btn-apple').removeClass('display-none');
            }
        }
    }

    handleiOSsocialButton();

    if($('body').hasClass('is-app')){
        //$(document).on('click', 'a[href^="/"]', function(e) {
        $(document).on('click', '.js-mobile-nav-item.active', function(e){
            e.preventDefault();
            e.stopImmediatePropagation();
        });

        $(document).on('click', '.js-app-footer .nav-item:not(.active, .nav-item-more), .app-modal .js-mobile-nav-item:not(.active), a[href^="/"]', function(e) {
            // hier kann man mehrere weitere Klassen noch ausschließen, um sie normal aufzurufen und nicht per Ajax
            if($(this).hasClass('no-ajax-call-in-app')){
                return;
            }
            e.preventDefault();
            $elem = $(this);
            var item_href = $(this).attr('href');

            if($elem.is('.js-mobile-nav-item')){
                $('.js-mobile-nav-item').removeClass('active');
            }else if($elem.is('.nav-item')){
                $('.nav-item').removeClass('active');
            }
            $elem.addClass('active');

            if($elem.closest('.navbar-nav').length){
                $(".navbar-collapse").collapse('hide');
            }else if($elem.is('.js-mobile-nav-item')){
                //$(".modal").modal('hide');
                //$(this).closest(".modal").modal('toggle');
                $(this).closest(".modal").modal('hide');
            }
    
            loadUrlPerAjaxToContent(item_href);
        });
    }

    function loadUrlPerAjaxToContent(pathname){
        var url_ajax_load_timeout = setTimeout(function() {
            $('.content-wrapper').addClass('is-loading');
         }, 1000);  // Ladeanimation nur anzeigen, wenn Laden per Ajax länger als 1 Sekunde dauert

        $.ajax({
            type: 'POST',
            url: pathname,
            data: {
                'page_load_type': 'is-ajax-app-call'
            }
        }).done(function (data) {
            var $parsed_data = $($.parseHTML(data));
            var $loaded_title = $parsed_data.filter("title");
            var $loaded_header = $parsed_data.filter(".header");
            var $loaded_footer = $parsed_data.filter(".js-app-footer");
            var $loaded_app_modal = $parsed_data.filter("#modal-app-more");
            var $loaded_lang_texts_and_templates = $parsed_data.filter(".js-language-texts-and-templates");
            var $loaded_content_wrapper = $parsed_data.filter(".content-wrapper");  // muss wohl so gemacht. Keine Ahnung ob da irgendwelche falschen HTML Elemente drin sind.

            // body attribute auslesen und neu setzen
            var data = data.replace('<body', '<body><div id="body"').replace('</body>','</div></body>');
            var $body = $(data).filter('#body');
            $('body').attr('data-current-locale', $body.attr('data-current-locale'));
            $('body').attr('data-page-language', $body.attr('data-page-language'));

            if($loaded_content_wrapper.is('.content-wrapper.startpage')){
                $('.content-wrapper').addClass('startpage');
            }else{
                $('.content-wrapper').removeClass('startpage');
            }
            
            $('.content-wrapper').html($loaded_content_wrapper.html());
            $('.header').replaceWith($loaded_header);
            $('#modal-app-more').replaceWith($loaded_app_modal);
            $('.js-language-texts-and-templates').replaceWith($loaded_lang_texts_and_templates);
            // $('.content-wrapper').removeClass('is-loading');
            // $('.modal-backdrop').remove();
            // $('body').removeClass('modal-open');
            inviewLazyLoad();
            initiateTooltipster();
            validateAllForms();
            sortableWishes();
            checkOverviewTabActive();
            checkWishStatsChanged();
            setVariablesForLanguage();
            handleMobileElementsVisibility();
            initiateJsAnimated();
            checkBannerCookie();
            handleiOSsocialButton();

            setTimeout(function() {
                $('.js-app-footer').replaceWith($loaded_footer);
            }, 150);

            $(window).scrollTop(0);

            if($loaded_content_wrapper.find('.owl-carousel').length){
                initiateOwlCarousel();
            }
            
            // lade alle scripts im content-wrapper nach
            var scripts = $(data).find(".content-wrapper script[src]");
            $(scripts).each(function() {
                if ($(this).attr("src")) {
                    $.getScript($(this).attr("src"));
                }
            });
            
            if (history && history.replaceState) {
                history.replaceState(null, $loaded_title.text(), pathname );  // Beim Laden der Seite sollte einmal ein PushState mit der Startseite gemacht werden!
                document.title = $loaded_title.text();
            }

            /* beim ganze body laden nicht mehr notwendig! */
            if ($('.js-add-wish-plus').length) {
                $('#pageup').addClass('page-has-plus-button');
            }else{
                $('#pageup').removeClass('page-has-plus-button');
            }
        }).fail(function () {
            // showNotify(lang_ajax_save_error_text, 'error');
        }).always(function() {
            clearTimeout(url_ajax_load_timeout);
            $('.content-wrapper').removeClass('is-loading');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
            $(document).trigger('loadedUrlPerAjaxToContent'); // custom event, welches wir abfragen können
        });
    }

    $('body').on('click', '.js-ajax-json-action-wishlist', function(e) {
        e.preventDefault();
        var ajax_action_failed_message = $(this).data('ajax-action-failed-message');
        var url = $(this).data('href');

        $.ajax({
            type:'GET',
            url: url,
            dataType: 'json'
        }).done(function (json) {
            if(Object.keys(json).length){
                if (json.status == 'success') {
                    reloadWishesSimple(function(){
                        checkWishStatsChanged();
                        showNotify(json.message, 'success');
                    });
                }else{
                    showNotify(json.message, 'error');
                }
            }else{
                showNotify(ajax_action_failed_message, 'error');
            }
        }).fail(function () {
            showNotify(ajax_action_failed_message, 'error');
        });
    });

    $('body').on('click', '.js-close-swal', function(e) {
        Swal.close();
    });

    $('body').on('click', '.js-swal-open-copy-move-wish', function(e) {
        e.preventDefault();
        var swal_title = $(this).data('swal-title');
        var swal_text = $(this).data('swal-text');
        var swal_show_confirm_btn = true;
        var swal_width;
        var swal_target = $(this).data('swal-target');
        //var swal_icon = 'info';
        var copy_move_shortcut = $(this).data('copymove-type');
        var wish_id = $(this).closest('.wish').attr('data-wish-id');
        var $target_html = $(swal_target);
        
        $target_html.find('.js-ajax-json-action-wishlist').each(function(index, elem) {
            var urlParams = new URLSearchParams($(elem).attr('data-href'));
            urlParams.set('wish_id', wish_id);
            urlParams.set('type', copy_move_shortcut);
            $(elem).attr('data-href', decodeURIComponent(urlParams));
        });
        $target_html.find('.js-swal-text').text(swal_text);
        var target_html = $target_html.html();

        $(swal_target).find('.tooltipstered').tooltipster('destroy');  // hier zerstören, da sonst kopierter Inhalt und kein nochmaliges Tooltipster!

        if (typeof $(this).data('swal-width') !== 'undefined') {
            swal_width = $(this).data('swal-width');
        }

        if(typeof $(this).data('show-confirm-button') !== 'undefined'){
            swal_show_confirm_btn = $(this).data('show-confirm-button');
        }

        CustomHashSwal.fire({
            title: swal_title,
            width: swal_width,
            showConfirmButton: swal_show_confirm_btn,
            showCloseButton: true,
            html: target_html,
            //icon: swal_icon,
            //iconHtml: '<i class="fa fa-fw fa-exclamation" aria-hidden="true"></i>'
        });
    });

    $('body').on('click', '.js-select-predefined-design-btn', function(e) {
        $('.js-selected-predefined-design-input').val($(this).data('design-id'));
        $('.js-select-predefined-banner').attr('src', $(this).find('.js-select-predefined-design-img').attr('src'));
        Swal.close();
    });

    $('body').on('click', '.js-trigger-other-file-input', function(e) {
        var trigger_elem = $(this).attr('data-trigger-file-input-elem');
        
        if($(trigger_elem)[0].files.length == 0){
            $(trigger_elem).trigger('click');
        }else{
            $(trigger_elem).trigger('change');
        }
    });

    /* CROPPERJS STARTS */
    (function() {
        var cropper;

        $('body').on('click', '.js-image-upload-cropper-preview', function (e) {
            $(this).val(null);
            checkAndResetCropperPreview(this);
        });

        $('body').on('change', '.js-image-upload-cropper-preview', function (e) {
            checkAndResetCropperPreview(this);
            var $this_input = $(this);
            var target_preview_elem = $(this).data('preview-element');
            var target_preview_elem2 = $(this).data('preview-element2');
            var file;
    
            if ($().validate && $(".form-general").length) {
                if ($(this).valid()) {
                    if (this.files && this.files[0]) {
                        file = this.files[0];
                        var img = new Image();
                        var img_url;

                        if (URL) {
                            img_url = URL.createObjectURL(file);
                        } else if (FileReader) {
                            reader = new FileReader();
                            reader.onload = function (e) {
                                img_url = reader.result;
                            };
                            reader.readAsDataURL(file);
                        }
    
                        img.onload = function () {
                            $this_input.attr('data-image-width', img.naturalWidth);
                            $this_input.attr('data-image-height', img.naturalHeight);

                            if($this_input.valid()){  // nochmal ausführen, da jetzt die Bild-Dimensionen überprüft werden!
                                $('.js-image-cropper-img').attr('src', img_url);
                                $('#modal-image-cropper .js-preview-element-class-name').attr('data-preview-element', target_preview_elem);
                                if(typeof target_preview_elem2 !== 'undefined'){
                                    $('#modal-image-cropper .js-preview-element-class-name').attr('data-preview-element2', target_preview_elem2);
                                }else{
                                    $('#modal-image-cropper .js-preview-element-class-name').removeAttr('data-preview-element2');
                                }
                                loadImageCropper();
                            }else{
                                return false;
                            }
                        };
                        img.src = img_url;
                    }
                }
            }
        });

        $('body').on('click', '.js-cropper-action-btns button', function(e) {
            var cropperjs_action = $(this).data('action');
            var method_name = cropperjs_action.substring(0, cropperjs_action.indexOf('('));
            var method_param = cropperjs_action.match( /\((.*)\)/)[1];

            if(cropper) {
                cropper[method_name](method_param);
            }
        });

        $('body').on('click', '#js-cropperjs-crop', function(e) {
            var preview_elem = $('#modal-image-cropper').find('.js-preview-element-class-name').attr('data-preview-element');
            var preview_elem2 = $('#modal-image-cropper').find('.js-preview-element-class-name').attr('data-preview-element2');
        
            writeCroppedDataToImage(function(){
                if($('#modal-image-cropper').find('.js-active-preview-element-class-name').attr('data-active-preview-element') == preview_elem && typeof preview_elem2 !== 'undefined' && preview_elem2 != ''){
                    cropper.destroy();
                    $('#modal-image-cropper').find('.js-active-preview-element-class-name').attr('data-active-preview-element', preview_elem2)
                    initCropper(preview_elem2);
                }else{
                    // beenden
                    $('#modal-image-cropper').modal('hide');
                }
            });
        });
        
        $('body').on('shown.bs.modal', '#modal-image-cropper', function (e) {
            var preview_elem = $('#modal-image-cropper').find('.js-preview-element-class-name').attr('data-preview-element');  // immer erstes Element
            $('#modal-image-cropper').find('.js-active-preview-element-class-name').attr('data-active-preview-element', preview_elem);
            if(preview_elem == '.js-image-preview-wrapper-profile-photo'){
                $('#modal-image-cropper').find('.modal-body').addClass('modal-cropper-is-profile-photo');
            }else{
                $('#modal-image-cropper').find('.modal-body').removeClass('modal-cropper-is-profile-photo');
            }
            initCropper(preview_elem);
        }).on('hidden.bs.modal', function () {
            if(cropper){
                cropper.destroy();
                cropper = null;    
            }
        });

        function loadImageCropper(){
            $('#modal-image-cropper').modal('show');
        }

        function checkAndResetCropperPreview(elem){
            var $this_input = $(elem);
            var target_preview_elem = $(elem).data('preview-element');
            var target_preview_elem2 = $(elem).data('preview-element2');
            var placeholder_img = $(target_preview_elem).find('.js-image-preview-cropperjs').attr('data-empty-src');
    
            if(target_preview_elem != '.js-image-preview-wrapper-profile-photo'){
                $this_input.prop('required', true);
            }
            $(target_preview_elem).find('.js-cropped-data').prop('required', true);
            $(target_preview_elem2).find('.js-cropped-data').prop('required', true);

            $this_input.removeAttr('data-image-width');
            $this_input.removeAttr('data-image-height');
    
            // Vorschaubilder zurücksetzen
            $(target_preview_elem).find('.js-image-preview-cropperjs').attr('src', placeholder_img);
            $(target_preview_elem2).find('.js-image-preview-cropperjs').attr('src', placeholder_img);

            if($(elem)[0].files.length == 0){
                if(target_preview_elem == '.js-image-preview-wrapper-profile-photo'){
                    $(target_preview_elem).find('.js-cropped-data').prop('required', false);
                }
                $(target_preview_elem).find('.js-cropped-data').val('');
                $(target_preview_elem2).find('.js-cropped-data').val('');
            }
        }
    
        function initCropper(preview_elem){
            var image = $('.js-image-cropper-img')[0];
            var timeout = null;
            var $preview_elem = $(preview_elem);
            var aspect_ratio = $preview_elem.attr('data-aspect-ratio');
            var tmp_arr = aspect_ratio.split(/[*/]/);
            var aspect_ratio = tmp_arr[0]/tmp_arr[1]; // 1920 / 820 z.b. umwandeln von String in Kalkulation
    
            cropper = new Cropper(image, {
                dragMode: 'move',
                autoCrop: true,
                autoCropArea : 0.8, // default 80% vom Image
                //cropBoxMovable: false,
                aspectRatio: aspect_ratio,
                cropBoxResizable: false,
                zoomable: true,
                scalable: true,
                //zoomable: true,
                //minContainerHeight  : 400,
                //minContainerWidth   : 400,
                //minCanvasWidth      : 1920, 
                //minCanvasHeight     : 820,
                //minCanvasWidth: 1920,
                //minCanvasHeight: 820,
                //minCropBoxWidth: 1920,
                viewMode: 1,  // 1 oder 3 gut
                crop: function (e) {
                    var data = e.detail;            
                    $preview_elem.find('.js-cropped-data').val(JSON.stringify(data));
                    clearTimeout(timeout);
                    timeout = setTimeout(function () {
                        writeCroppedDataToImage(function(){});
                    }, 750);
                }
            });
        }
    
        function writeCroppedDataToImage(callback){
            var $active_preview_elem = $($('#modal-image-cropper').find('.js-active-preview-element-class-name').attr('data-active-preview-element'))
            var canvas;
            
            if (cropper) {
                canvas = cropper.getCroppedCanvas({
                    //width: 1920, //height: 820, //minWidth: 1920, //minHeight: 820
                    maxWidth: 1200,  // maxWidth und maxHeight sollte gleichzeitig gesetzt sein, sonst gibt es manchmal komische weiße Ränder!
					maxHeight: 1200
                });
                $active_preview_elem.find('.js-image-preview-cropperjs').attr('src', canvas.toDataURL());
            }
            callback();
        }
    }());
    /* CROPPERJS ENDS */

    /* FAQ SEARCH STARTS */
    $('.faq-container').data('original-html', $('.faq-container').html());
    
    $('body').on('keyup', '.js-faq-search', function(e) {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            $('.faq-container').html($('.faq-container').data('original-html'));  // hier wieder original Inhalt reinladen
            handleFaqSearchInput();
            inviewLazyLoad();  // damit die LazyLoad Images hier bei nachgeladenem Content auch funktionieren.
            if($('.js-faq-search').val().trim() != ''){
                $.ajax({
                    type: "POST",
                    url: "/allgemein/saveFAQSearch",
                    data: { url : $('.js-faq-search').val().trim() }
                });
            }
        }, 500);
    });

    function handleFaqSearchInput(){
        var $input = $('.js-faq-search');
        var keywords = $input.val().trim().toLowerCase();

        if(keywords != '' && keywords.length >= 2){
            $input.closest('.add-on').addClass('input-group');
            $input.closest('.add-on').find('.input-group-btn').removeClass('display-none');
            
            $('.faq-container').find('.accordion-headline').each(function(i){
                var $element = $(this);
                var words = keywords.split(' ');
                var exists = true;
                words.forEach (function (word, index) {
                    if(!($element.text().toLowerCase().includes(word) || $element.next('div.tab-pane').text().toLowerCase().includes(word)))
                        exists = false;
                });

                if(exists) {
                    words.forEach (function (word, index) {
                        if($element.text().toLowerCase().includes(word) || $element.next('div.tab-pane').text().toLowerCase().includes(word) ){
                            $element.removeClass('hidden');
                            $element.next('div.tab-pane').removeClass('hidden');

                            if($element.text().toLowerCase().includes(word)){
                                highlightText($element, word);
                            }
                            if($element.next('div.tab-pane').text().toLowerCase().includes(word)){
                                highlightText($element.next('div.tab-pane'), word);
                            }
                        }else{
                            $element.addClass('hidden');
                            $element.next('div.tab-pane').addClass('hidden');
                        }
                    });
                }else{
                    $element.addClass('hidden');
                    $element.next('div.tab-pane').addClass('hidden');
                }
            });
        }else{
            $input.closest('.add-on').removeClass('input-group');
            $input.closest('.add-on').find('.input-group-btn').addClass('display-none');
        }
    }

    function highlightText($elem, keywords) {
        var par_html = $elem[0].innerHTML;
        var paragraph = $elem[0];
        var search = keywords;
        var regex = new RegExp("(" + search + ")(?!([^<]+)?>)", "gi");  // https://stackoverflow.com/questions/26951003/javascript-replace-all-but-only-outside-html-tags

        paragraph.innerHTML = par_html.replace(regex, '<mark>$&</mark>');
    }
    
    $('body').on('click', '.js-faq-search-button', function(e) {
        $('.js-faq-search').val('').trigger('keyup');
        handleFaqSearchInput();
    });
    /* FAQ SEARCH ENDS */

    /************************************************* Wishbob functions ENDS *************************************************/
});


function chartsDropdown(name, anzahl){
    document.getElementById(name).selectedIndex = document.getElementById(name).selectedIndex + anzahl;
    $('#'+name).change();
}

// Diese Funktion ist bewusst außerhalb vom jquery Document ready!
function reloadWishesSimple(callback){
    if (window.jQuery) {
        $('#wunschlisteverwalten').load(' #wunschlisteverwalten > *', function(){    // "> *" nimmt alle children von dem gefundenen Element
            inviewLazyLoad();  // damit die LazyLoad Images hier bei nachgeladenem Content auch funktionieren.
            sortableWishes();  // fix 09.10.2024 - hat hier gefehlt und die Funktion in eine globale window.function umgebaut
            handleMobileElementsVisibility();
            callback();
        });  // goes on current url
    }
}

// Funktion, um aus Android oder später vielleicht auch iOS die Resume Funktion mitzubekommen. Wenn die App vom Hintergrund in den Vordergrund geholt wird.
function onResumeApp(){
    reloadWishesSimple(function(){});
}

// Google One Tap Login
function handleGoogleOneTapLoginCredentialResponse (token){
    // diese Variablen sind im Doc Ready, aber hier nicht erreichbar, daher hier nochmal
    var lang_error_occured = $('#js-general-texts').data('error-occurred-text');  // Ein Fehler ist aufgetreten.
    var lang_try_again = $('#js-general-texts').data('error-try-again-text');  // Versuche es bitte erneut.

    $.ajax({
        type: "POST",
        url: '/json/googleOneTapLogin',
        data: { id_token: token },
    }).done(function (response) {
        var status = response.status;
        var message = response.message;
        var redirectURL = response.redirectURL;

        if (status == 'success') {
            showNotify(message, 'success');
            setTimeout(function(){ 
                location.reload();
            }, 1000);
        }else{
            showNotify(message, 'error', 8000);
            location.href = redirectURL;
        }
    }).fail(function () {
        showNotify(lang_error_occured + ' ' + lang_try_again, 'error');
    });
}